import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import * as $ from 'jquery';  // 使用jQuery
import { Location } from '@angular/common';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { ElMessageService } from 'element-angular';
import * as Driver from 'driver.js';

import { LoginUser } from '../../models/landing-page/loginUser';
import { LoginedInfo } from '../../models/landing-page/loginedInfo';
import { ValidCode } from '../../models/landing-page/validCode';
import { CheckNewPhone } from '../../models/landing-page/newPhone';
import { SignUpUser } from '../../models/landing-page/signUpUser';
import { HttpResult } from '../../models/landing-page/httpResult';
import { SignUpResult } from '../../models/landing-page/signupResult';
import { ResetPwd } from '../../models/landing-page/resetPwd';
import { WxLogin } from '../../models/landing-page/wxLogin';
import { WxLoginResult } from '../../models/landing-page/wxLoginResult';
import { BindPhone } from '../../models/landing-page/bindPhone';
import { Decimal } from 'decimal.js';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  autoCutoffSalaryMonthDate: any;
  clear: any;
  roleList: any = []; // 企业的职位列表
  hideSettingTabs: any; // 控制 设置模块的 tabs的隐藏和显示
  loopCheckPaymentBill: any; // 轮序检测支付但状态，检测支付完成或失败，放在这里，是为了跳转到其他页面的时候，可以清除计时器
  addBgColorIndex: any;
  nickname: any; // 微信昵称
  gender: any; // 微信号性别
  batchTask: any;
  isLoggedIn = false;
  loginedInfo: LoginedInfo; // 登陆后返回信息
  loadImageShow = false; // 加载中图片显示
  user: LoginUser;
  redirectUrl: string;
  rememberPwd: any;
  accesstoken: string;
  totalCommodityMoney: any;
  moduleHideList: any = {
    specimen: null,
    tradeOrder: null,
    purchaseOrder: null,
    companyTask: null,
    staffs: null,
    recordStock: null,
    customerBills: null,
    revenue: null
  };
  totalAdminAuditings: any; // 管理员操作审核--总条数
  totalEmployeeAuditings: any; // 员工操作审核--总条数
  userInfo: any; // 当前登录用户信息
  unionid: string; // 微信登录的 unionid
  employer = false; // 老板身份
  adminSpecimenReading = false;
  adminSpecimen = false; // 样版管理权限（管理员）
  adminSpecimenAuditing = false; // 样版审批权限（管理员）
  adminTradeOrderReading = false;
  adminTradeOrder = false; // 订单管理权限（管理员）
  adminTradeOrderAuditing = false; // 订单审批权限（管理员）
  adminPurchaseOrderReading = false;
  adminPurchaseOrder = false; // 采购管理权限（管理员）
  adminPurchaseOrderAuditing = false; // 采购审批权限（管理员）
  adminCompanyTaskReading = false;
  adminCompanyTask = false; // 生产任务管理权限（管理员）
  adminCompanyTaskAuditing = false; // 生产任务审批权限（管理员）
  adminWorkstage = false; // 工序单价（管理员）
  adminBundle = false; // 扎号打菲（管理员）
  adminProductionData = false; // 生产制单权限（管理员）
  adminSchedule = false; // 进度管理权限（管理员）
  adminBatchDailyWork = false; // 生产任务上数权限（管理员）
  adminStaffsReading = false;
  adminStaffs = false; // 员工管理权限（管理员）
  adminStaffsAuditing = false; // 员工审批权限（管理员）
  adminCompanySalaryReading = false;
  adminCompanySalary = false; // 工资管理权限（管理员）
  adminCompanySalaryAuditing = false; // 工资审批权限（管理员）
  adminAuditingReading = false;
  adminAuditing = false; // 超数审核权限（管理员）
  adminCustomerBillsReading = false;
  adminCustomerBills = false; // 合作企业账单权限（管理员）
  adminCustomerBillsAuditing = false; // 合作企业账单审批权限（管理员）
  adminRecordStockReading = false;
  adminRecordStock = false; // 库存管理权限（管理员）
  adminRecordStockAuditing = false; // 库存审批权限（管理员）
  adminRevenueReading = false;
  adminRevenue = false; // 收支管理权限（管理员）
  adminRevenueAuditing = false; // 收支审批权限（管理员）
  adminAuthority = false; // 权限管理权限（管理员）
  adminNoticeBoard = false; // 公告权限（管理员）
  hideTaskPrice: any; // 是否对员工隐藏单价参数
  hideTaskPriceStartMonth: string; // 对员工隐藏单价的开始月份，即从哪个月开始对员工隐藏单价
  hideSalary: any;
  hideSalaryEndMonth: string;
  hideColleague: any;
  hideTaskList: any;
  hideProduction: any;
  controlScanningOrder: any;
  fixedSkill: any;
  customerList: any;
  bigImageShow = false; // 初始为小图
  indexBigImage: any;
  bigImageArr: any;
  bigPictrue: any;
  firstLoad = true; // 用于判断是否是第一次加载
  firstLoadTip = true; // 用于判断无员工提示框第一次加载
  haveDeadlineTip = false; // 用于判断模块过期的提示(一次)
  showAllTips = true;
  comIntegral = 0;
  moduleDeadArr = [];
  softwareUpdate =
    '【服饰好帮手】是服装管理ERP系统:\n' +
    '1.样版|订单|采购|生产|工资|仓库|账单|收支;\n' +
    '2.注册即可使用，不限制使用人数和设备;\n' +
    '3.微信搜索【服饰好帮手】小程序同步使用;\n' +
    '4.关注微信公众号接收企业内部信息推送;\n' +
    '5.适合企业间协同办公，接单外发，跟踪订单;\n' +
    '6.适合档口批发仓库进销存，生成账单;\n' +
    '7.适合工厂打版、管理生产进度、核算成本;\n' +
    '8.适合电子工票、扫码计菲、计算工资;';
  scrollDelay: any;
  colorList = ['白色', '黑色', '蓝色', '红色', '黄色', '绿色', '紫色', '灰色', '粉色', '棕色', '橙色', '褐色', '银色',
    '深红', '粉红', '玫红', '紫红', '橘红', '灰红', '莓红', '枣红', '荔枝红', '珊瑚红',
    '浅黄', '亮黄', '新黄', '姜黄', '土黄', '米黄', '卡其', '杏色', '浅卡', '驼色',
    '军绿', '浅绿', '蓝绿', '花绿', '墨绿', '果绿',
    '深灰', '浅灰', '花灰',
    '蓝灰', '湖蓝', '浅蓝', '花蓝', '水蓝', '彩蓝', '牛仔蓝', '宝蓝', '迪蓝',
    '咖啡', '焦糖', '米白',
    '炭黑', '花布', '迷彩', '条纹', '豹纹', '斑点'];
  totalAmountArr: any = []; // 各个尺码的数量总和
  allSizeTotal = 0; // 所有尺码的数量总和

  constructor(
    private http: HttpClient,
    private location: Location,
    private router: Router,
    private message: ElMessageService,
  ) {
    document.addEventListener('click', function () {
      $('.codeListWrap').hide();
    });
  }

  login(user: LoginUser): Observable<LoginedInfo> {
    const url = '/login';
    return this.http.post<LoginedInfo>(`${url}`, user, httpOptions)
      .pipe(
        tap((response) => { }),
        // catchError('TBD')
      );
  }

  // 验证个人信息是否完善，如果个人信息不完善，则跳转到个人信息页面，要求用户完善个人资料
  perfectPersonInfo() {
    if (!this.userInfo.chinesename) {
      this.message.setOptions({
        center: true
      });
      this.message['warning']('请先完善个人资料');
      const url = window.location.href;
      if (url.indexOf('personal-informations') < 0) {
        this.router.navigateByUrl('/workspace/personal-informations');
        return;
      }
    }
  }

  isWorkStageNameAndRemarkTextOver(workStage) {
    if (workStage && workStage.length > 0) {
      let nameOver = false;
      let remarkOver = false;
      workStage = Array.isArray(workStage) ? workStage : workStage.join(',');
      workStage.forEach((item, index) => {
        if (item && item.name && item.name.length > 100) {
          nameOver = index + 1;
        }
        if (item && item.remark && item.remark.length > 256) {
          remarkOver = index + 1;
        }
      });
      if (nameOver || remarkOver) {
        this.message.setOptions({
          center: true,
          zIndex: 9999
        });
        this.message['warning'](nameOver ? `工序${nameOver}名称限100字` : `工序${remarkOver}备注限256字`);
        return true;
      } else return false;
    } else return false;
  }

  // 降序数字与字符混合自定义排序
  arrayAscNumberAndCharCustomSort(a, b) {
    a = (a === 0) ? a : (a || '');
    b = (b === 0) ? b : (b || '');
    const isNumA = !isNaN(a);
    const isNumB = !isNaN(b);
    function extractNumbers(text) {
      if (text) {
        return text.match(/\d+/g) || [];
      } else {
        return [];
      }
    }
    if (isNumA && isNumB) {
      return parseFloat(a) - parseFloat(b);
    } else if (isNumA) {
      // 如果 a 是数字而 b 不是，看b能否提取出数字，否则数字排前
      const numbers = extractNumbers(b);
      return numbers.length > 0 ? parseFloat(a) - parseFloat(numbers[0]) : -1;
    } else if (isNumB) {
      // 如果 b 是数字而 a 不是，看b能否提取出数字，否则数字排前
      const numbers = extractNumbers(a);
      return numbers.length > 0 ? parseFloat(numbers[0]) - parseFloat(b) : 1;
    } else {
      // 如果都是字符串，看看能不能都提数字出来
      const numbersA = extractNumbers(a);
      const numbersB = extractNumbers(b);
      // 如果都有数字，比较
      if (numbersA.length > 0 && numbersB.length > 0) {
        return parseFloat(numbersA[0]) - parseFloat(numbersB[0]);
        // 如果a有，b没有
      } else if (numbersA.length > 0 && numbersB.length === 0) {
        return 1;
        // 如果b有，a没有
      } if (numbersB.length > 0 && numbersA.length === 0) {
        return -1;
      } else {
        // 如果都不是数字，按字典顺序排序
        return a.localeCompare(b);
      }
    }
  }

  // 升序数字与字符混合自定义排序
  arrayDescNumberAndCharCustomSort(a, b) {
    a = (a === 0) ? a : (a || '');
    b = (b === 0) ? b : (b || '');
    const isNumA = !isNaN(a);
    const isNumB = !isNaN(b);
    function extractNumbers(text) {
      if (text) {
        return text.match(/\d+/g) || [];
      } else {
        return [];
      }
    }
    if (isNumA && isNumB) {
      return parseFloat(b) - parseFloat(a);
    } else if (isNumA) {
      // 如果 a 是数字而 b 不是，看b能否提取出数字，否则数字排前
      const numbers = extractNumbers(b);
      return numbers.length > 0 ? parseFloat(numbers[0]) - parseFloat(a) : -1;
    } else if (isNumB) {
      // 如果 b 是数字而 a 不是，看b能否提取出数字，否则数字排前
      const numbers = extractNumbers(a);
      return numbers.length > 0 ? parseFloat(b) - parseFloat(numbers[0]) : 1;
    } else {
      // 如果都是字符串，看看能不能都提数字出来
      const numbersA = extractNumbers(a);
      const numbersB = extractNumbers(b);
      // 如果都有数字，比较
      if (numbersA.length > 0 && numbersB.length > 0) {
        return parseFloat(numbersB[0]) - parseFloat(numbersA[0]);
        // 如果a有，b没有
      } else if (numbersA.length > 0 && numbersB.length === 0) {
        return -1;
        // 如果b有，a没有
      } if (numbersB.length > 0 && numbersA.length === 0) {
        return 1;
      } else {
        // 如果都不是数字，按字典顺序排序
        return b.localeCompare(a);
      }
    }
  }

  // 降序数字与字符混合自定义排序
  ascBedNumberAndCharCustomSort(a, b) {
    a.bedNumber = (a.bedNumber === 0) ? a.bedNumber : (a.bedNumber || '');
    b.bedNumber = (b.bedNumber === 0) ? b.bedNumber : (b.bedNumber || '');
    const isNumA = !isNaN(a.bedNumber);
    const isNumB = !isNaN(b.bedNumber);
    function extractNumbers(text) {
      if (text) {
        return text.match(/\d+/g) || [];
      } else {
        return [];
      }
    }
    if (isNumA && isNumB) {
      return parseFloat(a.bedNumber) - parseFloat(b.bedNumber);
    } else if (isNumA) {
      // 如果 a 是数字而 b 不是，看b能否提取出数字，否则数字排前
      const numbers = extractNumbers(b.bedNumber);
      return numbers.length > 0 ? parseFloat(a.bedNumber) - parseFloat(numbers[0]) : -1;
    } else if (isNumB) {
      // 如果 b 是数字而 a 不是，看b能否提取出数字，否则数字排前
      const numbers = extractNumbers(a.bedNumber);
      return numbers.length > 0 ? parseFloat(numbers[0]) - parseFloat(b.bedNumber) : 1;
    } else {
      // 如果都是字符串，看看能不能都提数字出来
      const numbersA = extractNumbers(a.bedNumber);
      const numbersB = extractNumbers(b.bedNumber);
      // 如果都有数字，比较
      if (numbersA.length > 0 && numbersB.length > 0) {
        return parseFloat(numbersA[0]) - parseFloat(numbersB[0]);
        // 如果a有，b没有
      } else if (numbersA.length > 0 && numbersB.length === 0) {
        return 1;
        // 如果b有，a没有
      } if (numbersB.length > 0 && numbersA.length === 0) {
        return -1;
      } else {
        // 如果都不是数字，按字典顺序排序
        return a.bedNumber.localeCompare(b.bedNumber);
      }
    }
  }

  // 升序数字与字符混合自定义排序
  descBedNumberAndCharCustomSort(a, b) {
    a.bedNumber = (a.bedNumber === 0) ? a.bedNumber : (a.bedNumber || '');
    b.bedNumber = (b.bedNumber === 0) ? b.bedNumber : (b.bedNumber || '');
    const isNumA = !isNaN(a.bedNumber);
    const isNumB = !isNaN(b.bedNumber);
    function extractNumbers(text) {
      if (text) {
        return text.match(/\d+/g) || [];
      } else {
        return [];
      }
    }
    if (isNumA && isNumB) {
      return parseFloat(b.bedNumber) - parseFloat(a.bedNumber);
    } else if (isNumA) {
      // 如果 a 是数字而 b 不是，看b能否提取出数字，否则数字排前
      const numbers = extractNumbers(b.bedNumber);
      return numbers.length > 0 ? parseFloat(numbers[0]) - parseFloat(a.bedNumber) : -1;
    } else if (isNumB) {
      // 如果 b 是数字而 a 不是，看b能否提取出数字，否则数字排前
      const numbers = extractNumbers(a.bedNumber);
      return numbers.length > 0 ? parseFloat(b.bedNumber) - parseFloat(numbers[0]) : 1;
    } else {
      // 如果都是字符串，看看能不能都提数字出来
      const numbersA = extractNumbers(a.bedNumber);
      const numbersB = extractNumbers(b.bedNumber);
      // 如果都有数字，比较
      if (numbersA.length > 0 && numbersB.length > 0) {
        return parseFloat(numbersB[0]) - parseFloat(numbersA[0]);
        // 如果a有，b没有
      } else if (numbersA.length > 0 && numbersB.length === 0) {
        return -1;
        // 如果b有，a没有
      } if (numbersB.length > 0 && numbersA.length === 0) {
        return 1;
      } else {
        // 如果都不是数字，按字典顺序排序
        return b.bedNumber.localeCompare(a.bedNumber);
      }
    }
  }

  // 根据字段对数字与字符混合自定义排序
  fieldAndCharCustomSort(arr, field, sort = 'asc') {
    /**
     * 参数：
     *    arr 要排序数组
     *    field 要排序的字段
     *    sort 排序方式 asc 升序 desc 降序
     * 返回值： 排序后数组
     */
    function extractNumbers(text) {
      if (text) {
        return text.match(/\d+/g) || [];
      } else {
        return [];
      }
    }
    arr.sort((a, b) => {
      if (sort === 'asc') {
        a[field] = (a[field] === 0) ? a[field] : (a[field] || '');
        b[field] = (b[field] === 0) ? b[field] : (b[field] || '');
        const isNumA = !isNaN(a[field]);
        const isNumB = !isNaN(b[field]);
        if (isNumA && isNumB) {
          return parseFloat(a[field]) - parseFloat(b[field]);
        } else if (isNumA) {
          // 如果 a 是数字而 b 不是，看b能否提取出数字，否则数字排前
          const numbers = extractNumbers(b[field]);
          return numbers.length > 0 ? parseFloat(a[field]) - parseFloat(numbers[0]) : -1;
        } else if (isNumB) {
          // 如果 b 是数字而 a 不是，看b能否提取出数字，否则数字排前
          const numbers = extractNumbers(a[field]);
          return numbers.length > 0 ? parseFloat(numbers[0]) - parseFloat(b[field]) : 1;
        } else {
          // 如果都是字符串，看看能不能都提数字出来
          const numbersA = extractNumbers(a[field]);
          const numbersB = extractNumbers(b[field]);
          // 如果都有数字，比较
          if (numbersA.length > 0 && numbersB.length > 0) {
            return parseFloat(numbersA[0]) - parseFloat(numbersB[0]);
            // 如果a有，b没有
          } else if (numbersA.length > 0 && numbersB.length === 0) {
            return 1;
            // 如果b有，a没有
          } if (numbersB.length > 0 && numbersA.length === 0) {
            return -1;
          } else {
            // 如果都不是数字，按字典顺序排序
            return a[field].localeCompare(b[field]);
          }
        }
      } else {
        a[field] = (a[field] === 0) ? a[field] : (a[field] || '');
        b[field] = (b[field] === 0) ? b[field] : (b[field] || '');
        const isNumA = !isNaN(a[field]);
        const isNumB = !isNaN(b[field]);
        if (isNumA && isNumB) {
          return parseFloat(b[field]) - parseFloat(a[field]);
        } else if (isNumA) {
          // 如果 a 是数字而 b 不是，看b能否提取出数字，否则数字排前
          const numbers = extractNumbers(b[field]);
          return numbers.length > 0 ? parseFloat(numbers[0]) - parseFloat(a[field]) : -1;
        } else if (isNumB) {
          // 如果 b 是数字而 a 不是，看b能否提取出数字，否则数字排前
          const numbers = extractNumbers(a[field]);
          return numbers.length > 0 ? parseFloat(b[field]) - parseFloat(numbers[0]) : 1;
        } else {
          // 如果都是字符串，看看能不能都提数字出来
          const numbersA = extractNumbers(a[field]);
          const numbersB = extractNumbers(b[field]);
          // 如果都有数字，比较
          if (numbersA.length > 0 && numbersB.length > 0) {
            return parseFloat(numbersB[0]) - parseFloat(numbersA[0]);
            // 如果a有，b没有
          } else if (numbersA.length > 0 && numbersB.length === 0) {
            return -1;
            // 如果b有，a没有
          } if (numbersB.length > 0 && numbersA.length === 0) {
            return 1;
          } else {
            // 如果都不是数字，按字典顺序排序
            return b[field].localeCompare(a[field]);
          }
        }
      }
    });
  }

  // 融合新旧工序
  mixedWorkStage(newData, oldData, noProcedureNum, amount = 0) {
    if (!newData || !oldData) return;
    // 将老数据按 name 建立索引映射，方便快速查找
    const oldDataMap: any = new Map(oldData.map(item => [item && item.name, item]));
    newData.forEach(newItem => {
      if (newItem) {
        if (oldDataMap.has(newItem.name)) {
          // 如果老数据中已有此 name，仅更新 price
          oldDataMap.get(newItem.name).price = newItem.price || 0;
        } else {
          // 如果老数据中没有此 name，则追加新数据
          const newProduceObj: any = {};
          newProduceObj.name = newItem.name || '';
          newProduceObj.price = newItem.price || 0;
          newProduceObj.newMagnification = 1;
          newProduceObj.oldMagnification = 1;
          newProduceObj.maxAmount = amount;
          newProduceObj.remark = newItem.remark || '';
          if (!noProcedureNum) {
            newProduceObj.procedureNum = oldData.length + 1;
          }
          oldData.push(newProduceObj);
        }
      }
    });
  }


  // 检测字段是否超长
  isTextOverLength(obj, keyObj, len) {
    let isOver = false;
    const keys = Object.keys(keyObj);
    if (keys && keys.length > 0 && obj && len > 0) {
      for (let index = 0; index < keys.length; index++) {
        const key = keys[index];
        if (key && obj[key] && obj[key].length > len && keyObj[key]) {
          this.message.setOptions({ center: true, zIndex: 9999 });
          this.message['warning'](`${keyObj[key]}限${len}字`);
          isOver = true;
          break;
        }
      }
    }
    return isOver;
  }

  // 采购聚合自己
  purchaseAggregatedSelf(table, suppliesData, callback) {
    if (suppliesData && suppliesData.length > 1) {
      let dataTitle = suppliesData[0];
      let remainData = suppliesData.splice(1);
      let tableData = table.getData();
      // 拉出双方表头...采购只能关联其他表，而且在新建的时候
      let nameIndex = tableData[0].indexOf('物料名称');
      let noIndex = tableData[0].indexOf('物料编号');
      let colorIndex = tableData[0].indexOf('颜色');
      let colorNoIndex = tableData[0].indexOf('色号');
      let specIndex = tableData[0].indexOf('规格');
      let unitIndex = tableData[0].indexOf('单位');
      let amountIndex = tableData[0].indexOf('数量');
      let priceIndex = tableData[0].indexOf('单价');
      let moneyIndex = tableData[0].indexOf('金额');
      let offerIndex = tableData[0].indexOf('来源/供应商');
      let nameIndex1 = tableData[0].indexOf('物料名称');
      let noIndex1 = tableData[0].indexOf('物料编号');
      let colorIndex1 = tableData[0].indexOf('颜色');
      let colorNoIndex1 = tableData[0].indexOf('色号');
      let specIndex1 = tableData[0].indexOf('规格');
      let unitIndex1 = tableData[0].indexOf('单位');
      let amountIndex1 = tableData[0].indexOf('数量');
      let priceIndex1 = tableData[0].indexOf('单价');
      // let moneyIndex1 = tableData[0].indexOf('金额');
      let offerIndex1 = tableData[0].indexOf('来源/供应商');
      let otherTitle = [];
      // 表头融合
      if (offerIndex1 !== -1) {
        otherTitle = dataTitle.slice(offerIndex1 + 1);
        otherTitle.forEach(title => {
          if (title && tableData[0].indexOf(title) == -1) {
            tableData.forEach((item, index) => {
              index === 0 ? item.push(title) : item.push('');
            });
          }
        });
      }
      // 数据融合
      remainData.forEach(arr => {
        // 先对比名字，如果名字相等再比较剩下的，如果全等就数据聚合，不然就新加
        let name1 = arr[nameIndex1];
        let isPush = true;
        tableData.forEach((item, index) => {
          if (index > 0) {
            if (name1 === item[nameIndex]) {
              // 继续比较
              let no1 = arr[noIndex1];
              let color1 = arr[colorIndex1];
              let colorNo1 = arr[colorNoIndex1];
              let spec1 = arr[specIndex1];
              let unit1 = arr[unitIndex1];
              let price1 = arr[priceIndex1];
              let offer1 = arr[offerIndex1];
              if (no1 === item[noIndex] && color1 === item[colorIndex] && colorNo1 === item[colorNoIndex] && spec1 === item[specIndex] && unit1 === item[unitIndex] && price1 === item[priceIndex] && offer1 === item[offerIndex]) {
                // 聚合
                let val = item[amountIndex];
                let val1 = arr[amountIndex1];
                if (val && val1) {
                  tableData[index][amountIndex] = parseFloat(val) + parseFloat(val1);
                  isPush = false;
                  // 额外数据添加
                  otherTitle.forEach(title => {
                    if (title) {
                      let titleIndex = tableData[0].indexOf(title);
                      let dataTitleIndex = dataTitle.indexOf(title);
                      tableData[index][titleIndex] = tableData[index][titleIndex] + ', ' + arr[dataTitleIndex];
                    }
                  })
                }
              }
            }
          }
        });
        if (isPush) {
          // 直接添加
          let row = [];
          row[nameIndex] = arr[nameIndex1];
          row[noIndex] = arr[noIndex1];
          row[colorIndex] = arr[colorIndex1];
          row[colorNoIndex] = arr[colorNoIndex1];
          row[specIndex] = arr[specIndex1];
          row[unitIndex] = arr[unitIndex1];
          row[amountIndex] = arr[amountIndex1];
          row[priceIndex] = arr[priceIndex1];
          row[moneyIndex] = `=${this.getLetterFormIndex(amountIndex)}${tableData.length + 1}*${this.getLetterFormIndex(priceIndex)}${tableData.length + 1}`;
          row[offerIndex] = arr[offerIndex1];
          // 额外数据添加
          otherTitle.forEach(title => {
            if (title) {
              let titleIndex = tableData[0].indexOf(title);
              let dataTitleIndex = dataTitle.indexOf(title);
              row[titleIndex] = arr[dataTitleIndex];
            }
          })
          tableData.push(row);
        }
      });
      // 使用回调更新，在此函数更新不了调用的this对象
      callback(tableData);
    }
  }

  // 采购聚合各种关联表
  purchaseAggregatedForms(table, suppliesData, callback) {
    if (suppliesData && suppliesData.length > 1) {
      let dataTitle = suppliesData[0];
      let remainData = suppliesData.splice(1);
      let tableData = table.getData();
      // 拉出双方表头...采购只能关联其他表，而且在新建的时候
      let nameIndex = tableData[0].indexOf('物料名称');
      let noIndex = tableData[0].indexOf('物料编号');
      let colorIndex = tableData[0].indexOf('颜色');
      let colorNoIndex = tableData[0].indexOf('色号');
      let specIndex = tableData[0].indexOf('规格');
      let unitIndex = tableData[0].indexOf('单位');
      let amountIndex = tableData[0].indexOf('数量');
      let priceIndex = tableData[0].indexOf('单价');
      let moneyIndex = tableData[0].indexOf('金额');
      let offerIndex = tableData[0].indexOf('来源/供应商');
      let nameIndex1 = dataTitle.indexOf('物料名称');
      let noIndex1 = dataTitle.indexOf('物料编号');
      let colorIndex1 = dataTitle.indexOf('颜色');
      let colorNoIndex1 = dataTitle.indexOf('色号');
      let specIndex1 = dataTitle.indexOf('规格');
      let unitIndex1 = dataTitle.indexOf('单位');
      let amountIndex1 = dataTitle.indexOf('总用量');
      let priceIndex1 = dataTitle.indexOf('单价');
      let offerIndex1 = dataTitle.indexOf('来源/供应商');
      let otherTitle = [];
      // 表头融合
      if (offerIndex1 !== -1) {
        otherTitle = dataTitle.slice(offerIndex1 + 1);
        otherTitle.forEach(title => {
          if (title && tableData[0].indexOf(title) == -1) {
            tableData.forEach((item, index) => {
              index === 0 ? item.push(title) : item.push('');
            });
          }
        });
      }
      // 数据融合
      remainData.forEach(arr => {
        // 先对比名字，如果名字相等再比较剩下的，如果全等就数据聚合，不然就新加
        let name1 = arr[nameIndex1];
        let isPush = true;
        tableData.forEach((item, index) => {
          if (index > 0) {
            if (name1 === item[nameIndex]) {
              // 继续比较
              let no1 = arr[noIndex1];
              let color1 = arr[colorIndex1];
              let colorNo1 = arr[colorNoIndex1];
              let spec1 = arr[specIndex1];
              let unit1 = arr[unitIndex1];
              let price1 = arr[priceIndex1];
              let offer1 = arr[offerIndex1];
              if (no1 === item[noIndex] && color1 === item[colorIndex] && colorNo1 === item[colorNoIndex] && spec1 === item[specIndex] && unit1 === item[unitIndex] && price1 === item[priceIndex] && offer1 === item[offerIndex]) {
                // 聚合
                let val = item[amountIndex];
                let val1 = arr[amountIndex1];
                if (val && val1) {
                  tableData[index][amountIndex] = parseFloat(val) + parseFloat(val1);
                  isPush = false;
                  // 额外数据添加
                  otherTitle.forEach(title => {
                    if (title) {
                      let titleIndex = tableData[0].indexOf(title);
                      let dataTitleIndex = dataTitle.indexOf(title);
                      tableData[index][titleIndex] = tableData[index][titleIndex] + ', ' + arr[dataTitleIndex];
                    }
                  })
                }
              }
            }
          }
        });
        if (isPush) {
          // 直接添加
          let row = [];
          row[nameIndex] = arr[nameIndex1];
          row[noIndex] = arr[noIndex1];
          row[colorIndex] = arr[colorIndex1];
          row[colorNoIndex] = arr[colorNoIndex1];
          row[specIndex] = arr[specIndex1];
          row[unitIndex] = arr[unitIndex1];
          row[amountIndex] = arr[amountIndex1];
          row[priceIndex] = arr[priceIndex1];
          row[moneyIndex] = `=${this.getLetterFormIndex(amountIndex)}${tableData.length + 1}*${this.getLetterFormIndex(priceIndex)}${tableData.length + 1}`;
          row[offerIndex] = arr[offerIndex1];
          // 额外数据添加
          otherTitle.forEach(title => {
            if (title) {
              let titleIndex = tableData[0].indexOf(title);
              let dataTitleIndex = dataTitle.indexOf(title);
              row[titleIndex] = arr[dataTitleIndex];
            }
          })
          tableData.push(row);
        }
      });
      // 使用回调更新，在此函数更新不了调用的this对象
      callback(tableData);
    }
  }

  // excel下标取出相应字母的func
  getLetterFormIndex(index) {
    let letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    if (index < 26) {
      return letters[index];
    } else {
      let quotient = Math.floor(index / 26);
      let remainder = index % 26;
      if (quotient > 0) {
        result += letters[quotient - 1];
      }
      result += letters[remainder];
      return result;
    }
  }

  // 计算物料总数量，参数：表格数据，行数，返回值总数量
  calculateTotalMaterialQuantity(materialArr, y) {
    const amountIndex = materialArr[0].indexOf('数量');
    const totalIndex = materialArr[0].indexOf('总用量');
    const usageStr = materialArr[0].includes('单件用量') ? '单件用量' : '用量';
    const lossStr = materialArr[0].includes('单件损耗') ? '单件损耗' : '损耗';
    const usageIndex = materialArr[0].indexOf(usageStr);
    const lossIndex = materialArr[0].indexOf(lossStr);
    let usageValue = 0, lossValue = 0, amountValue = 0, totalValue = 0;
    if (usageIndex > 0) {
      if (Number(materialArr[y][usageIndex]) == 0 || isNaN(Number(materialArr[y][usageIndex]))) {
        usageValue = 0;
      } else {
        usageValue = parseFloat(materialArr[y][usageIndex]);
      }
    } else {
      usageValue = 0;
    }
    if (lossIndex > 0) {
      if (Number(materialArr[y][lossIndex]) == 0) {
        lossValue = 0;
      } else {
        lossValue = materialArr[y][lossIndex];
        if (lossValue.toString().includes('%')) {
          const numberValue = parseFloat(lossValue.toString().replace('%', ''));
          if (!isNaN(numberValue)) {
            lossValue = Math.round((usageValue * (Number(numberValue) / 100)) * 1e12) / 1e12;
            // lossValue = usageValue * (Number(numberValue) / 100);
          }
        }
      }
    } else {
      lossValue = 0;
    }
    if (amountIndex > 0) {
      if (Number(materialArr[y][amountIndex]) == 0 || isNaN(Number(materialArr[y][amountIndex]))) {
        amountValue = 0;
      } else {
        amountValue = parseFloat(materialArr[y][amountIndex]);
      }
    } else {
      amountValue = 0;
    }
    if (totalIndex > 0) {
      totalValue = Math.round((parseFloat(usageValue + '') + parseFloat(lossValue + '')) * parseFloat(amountValue + '') * 1e12) / 1e12;
      // totalValue = (parseFloat(usageValue + '') + parseFloat(lossValue + '')) * parseFloat(amountValue + '');
    } else {
      totalValue = 0;
    }
    return totalValue.toFixed(2);
  }
  // 物料数据添加公式
  addFormulaForSupplies(materialArr) {
    if (materialArr && materialArr.length > 1) {
      const amountIndex = materialArr[0].indexOf('数量');
      const totalIndex = materialArr[0].indexOf('总用量');
      const usageStr = materialArr[0].includes('单件用量') ? '单件用量' : '用量';
      const lossStr = materialArr[0].includes('单件损耗') ? '单件损耗' : '损耗';
      const usageIndex = materialArr[0].indexOf(usageStr);
      const lossIndex = materialArr[0].indexOf(lossStr);
      if (usageIndex > 0 && lossIndex > 0 && amountIndex > 0 && totalIndex > 0) {
        for (let i = 1; i < materialArr.length; i++) {
          materialArr[i][totalIndex] = this.calculateTotalMaterialQuantity(materialArr, i);
        }
      }
      return materialArr;
      // let useIndex = arr[0].findIndex(item => item === '单件用量');
      // let coastIndex = arr[0].findIndex(item => item === '单件损耗');
      // let amountIndex = arr[0].findIndex(item => item === '数量');
      // let sumIndex = arr[0].findIndex(item => item === '总用量');
      // let letterUse = this.getLetterFormIndex(useIndex);
      // let letterCoast = this.getLetterFormIndex(coastIndex);
      // let letterAmount = this.getLetterFormIndex(amountIndex);
      // if (useIndex !== -1 && coastIndex !== -1 && amountIndex !== -1 && sumIndex !== -1) {
      //   arr.forEach((item,index) => {
      //     let dataIndex = index + 1;
      //     if (dataIndex > 1) {
      //       // 表头下面数据添加公式
      //       item[sumIndex] = `=(${letterUse}${dataIndex}+${letterCoast}${dataIndex})*${letterAmount}${dataIndex}`;
      //     }
      //   });
      //   return arr;
      // } else {
      //   return null;
      // }
    } else {
      return null;
    }
  }

  // 物料添加一行带公式数据
  getRowWithFormula(arr, index) {
    if (arr.length > 0) {
      let useIndex = arr.findIndex(item => item === '单件用量');
      let coastIndex = arr.findIndex(item => item === '单件损耗');
      let amountIndex = arr.findIndex(item => item === '数量');
      let sumIndex = arr.findIndex(item => item === '总用量');
      let letterUse = this.getLetterFormIndex(useIndex);
      let letterCoast = this.getLetterFormIndex(coastIndex);
      let letterAmount = this.getLetterFormIndex(amountIndex);
      if (useIndex !== -1 && coastIndex !== -1 && amountIndex !== -1 && sumIndex !== -1) {
        let rows = [];
        arr.forEach(() => {
          rows.push('');
        });
        rows[sumIndex] = `=(${letterUse}${index}+${letterCoast}${index})*${letterAmount}${index}`;
        return rows;
      } else {
        return [];
      }
    }
  }

  // 采购物料添加一行带公式数据
  purchaseGetRowWithFormula(arr, index) {
    if (arr.length > 0) {
      let priceIndex = arr.findIndex(item => item === '单价');
      let amountIndex = arr.findIndex(item => item === '数量');
      let sumIndex = arr.findIndex(item => item === '金额');
      let letterPrice = this.getLetterFormIndex(priceIndex);
      let letterAmount = this.getLetterFormIndex(amountIndex);
      if (priceIndex !== -1 && amountIndex !== -1 && sumIndex !== -1) {
        let rows = [];
        arr.forEach(() => {
          rows.push('');
        });
        rows[sumIndex] = `=(${letterPrice}${index})*${letterAmount}${index}`;
        return rows;
      } else {
        return [];
      }
    }
  }

  // 物料添加一行带公式数据
  suppliesHelperGetRowWithFormula(headers, commodity, index) {
    const data = Array(headers.length).fill('');
    let nameIndex = headers.indexOf('物料名称');
    let noIndex = headers.indexOf('物料编号');
    let colorIndex = headers.indexOf('颜色');
    let shadeIndex = headers.indexOf('色号');
    let specIndex = headers.indexOf('规格');
    let unitIndex = headers.indexOf('单位');
    let partIndex = headers.indexOf('部位');
    let useIndex = headers.indexOf('单件用量');
    let coastIndex = headers.indexOf('单件损耗');
    let amountIndex = headers.indexOf('数量');
    let totalIndex = headers.indexOf('总用量');
    let priceIndex = headers.indexOf('单价');
    let offerIndex = headers.indexOf('来源/供应商');
    if (nameIndex !== -1) { data[nameIndex] = commodity.commodityCode; }
    if (noIndex !== -1) { data[noIndex] = commodity.serialCode; }
    if (colorIndex !== -1) { data[colorIndex] = commodity.color; }
    if (shadeIndex !== -1) { data[shadeIndex] = commodity.colorNumber; }
    if (specIndex !== -1) { data[specIndex] = commodity.specification; }
    if (unitIndex !== -1) { data[unitIndex] = commodity.unit; }
    if (partIndex !== -1) { data[partIndex] = commodity.place; }
    if (useIndex !== -1) { data[useIndex] = commodity.dosage; }
    if (coastIndex !== -1) { data[coastIndex] = commodity.loss; }
    if (amountIndex !== -1) { data[amountIndex] = commodity.amount; }
    if (totalIndex !== -1) { data[totalIndex] = `=(${this.getLetterFormIndex(useIndex)}${index}+${this.getLetterFormIndex(coastIndex)}${index})*${this.getLetterFormIndex(amountIndex)}${index}`; }
    if (priceIndex !== -1) { data[priceIndex] = commodity.price; }
    if (offerIndex !== -1) { data[offerIndex] = commodity.customer; }
    return data;
  }

  // 采购助手物料添加一行带公式数据
  purchaseHelperGetRowWithFormula(headers, commodity, index) {
    const data = Array(headers.length).fill('');
    let nameIndex = headers.indexOf('物料名称');
    let noIndex = headers.indexOf('物料编号');
    let colorIndex = headers.indexOf('颜色');
    let shadeIndex = headers.indexOf('色号');
    let specIndex = headers.indexOf('规格');
    let unitIndex = headers.indexOf('单位');
    let totalIndex = headers.indexOf('数量');
    let priceIndex = headers.indexOf('单价');
    let moneyIndex = headers.indexOf('金额');
    let offerIndex = headers.indexOf('来源/供应商');
    if (nameIndex !== -1) data[nameIndex] = commodity.commodityCode;
    if (noIndex !== -1) data[noIndex] = commodity.serialCode;
    if (colorIndex !== -1) data[colorIndex] = commodity.color;
    if (shadeIndex !== -1) data[shadeIndex] = commodity.colorNumber;
    if (specIndex !== -1) data[specIndex] = commodity.specification;
    if (unitIndex !== -1) data[unitIndex] = commodity.unit;
    if (totalIndex !== -1) data[totalIndex] = commodity.total;
    if (moneyIndex !== -1) data[moneyIndex] = `=(${this.getLetterFormIndex(totalIndex)}${index}*${this.getLetterFormIndex(priceIndex)}${index})`;
    if (priceIndex !== -1) data[priceIndex] = commodity.price;
    if (offerIndex !== -1) data[offerIndex] = commodity.customer;
    return data;
  }

  formatDate(date, fmt) {
    if (!date) {
      return '';
    }
    const o = {
      'M+': date.getMonth() + 1,                 // 月份
      'd+': date.getDate(),                    // 日
      'h+': date.getHours(),                   // 小时
      'm+': date.getMinutes(),                 // 分
      's+': date.getSeconds(),                 // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds()             // 毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
      }
    }
    return fmt;
  }

  getFormatYYYYMMDDHHmm(date) {
    const d = new Date(date || new Date());
    const year = d.getFullYear();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let hour = '' + d.getHours();
    let minute = '' + d.getMinutes();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    if (hour.length < 2) {
      hour = '0' + hour;
    }
    if (minute.length < 2) {
      minute = '0' + minute;
    }
    return [year, month, day].join('-') + ' ' + hour + ':' + minute;
  }

  getFormatMMDDHHmm(date) {
    const d = new Date(date || new Date());
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let hour = '' + d.getHours();
    let minute = '' + d.getMinutes();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    if (hour.length < 2) {
      hour = '0' + hour;
    }
    if (minute.length < 2) {
      minute = '0' + minute;
    }
    return [month, day].join('-') + ' ' + hour + ':' + minute;
  }

  getFormatYYYYMMDD(date) {
    if (!date) {
      return '';
    }
    const d = new Date(date);
    const year = d.getFullYear();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  getFormatYYYYMM(date) {
    const d = new Date(date || new Date());
    const year = d.getFullYear();
    let month = '' + (d.getMonth() + 1);
    if (month.length < 2) {
      month = '0' + month;
    }
    return [year, month].join('-');
  }

  // 获取上个月
  getFormatLastYYYYMM() {
    const d = new Date();
    let year = d.getFullYear();
    let month: any = '' + (d.getMonth());
    if (month.length < 2) {
      month = '0' + month;
    }
    if (month === '00') {
      year -= 1;
      month = 12;
    }
    return [year, month].join('-');
  }

  getFormatYYYY(date) {
    if (!date) {
      return '';
    }
    const d = new Date(date);
    const year = d.getFullYear();
    return year;
  }

  getFormatMMDD(date) {
    if (!date) {
      return '';
    }
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [month, day].join('-');
  }

  // 计算入职时间
  getWorkingDays(date) {
    if (!date) {
      return 0;
    }
    const d1: any = new Date();
    const d2: any = new Date(date);
    return Math.floor((d1 - d2) / (60 * 60 * 24 * 1000));
  }

  // 根据日期显示颜色，如果 截至日期-当前日期 > 3天，那么无色；3天 > 截至日期-当前日期 > 0天，那么黄色；截至日期-当前日期 < 0天，那么红色；
  compareDeadline(deadline) {
    if (!deadline) {
      return '';
    }
    const deadlineTime: any = new Date(deadline);
    const current: any = new Date();
    const result = (deadlineTime - current) / (60 * 60 * 24 * 1000);
    if (result > 3) {
      return '';
    } else if (result > 1) {
      return 'colorOrange';
    } else {
      return 'colorRed';
    }
  }

  // 验证手机号是否已经注册过
  findMobile(data: {}): Observable<CheckNewPhone> {
    const url = '/api/users/findMobile';
    return this.http.post<CheckNewPhone>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
          if (result.msg === true) {
            // 该手机号已注册过
          }
        }),
      );
  }

  getValidCode(code: ValidCode): Observable<HttpResult> {
    const url = '/api/validCodes/addValidCode';
    return this.http.post<HttpResult>(`${url}`, code, httpOptions)
      .pipe(
        tap((response) => {
          if (response.result === true) {
            // 发送成功
          } else {
            // 发送失败
          }
        }),
      );
  }

  resetNewPassword(code: ResetPwd): Observable<HttpResult> {
    const url = '/api/users/resetNewPassword';
    return this.http.post<HttpResult>(`${url}`, code, httpOptions)
      .pipe(
        tap((response) => {
          if (response.result === true) {
            // 验证码正确
          } else {
            // 验证码错误
          }
        }),
      );
  }

  // pc 端微信登录
  wxLoginOnPc(data: WxLogin): Observable<WxLoginResult> {
    const url = '/api/tools/getWxAccessToken';
    return this.http.post<WxLoginResult>(`${url}`, data, httpOptions)
      .pipe(
        tap((response) => {
          if (response) {
            // 验证码正确
            this.unionid = response.result.unionid;
          } else {
            // 验证码错误
          }
        }),
      );
  }

  // 绑定手机号
  bindPhoneForWx(data: BindPhone): Observable<WxLoginResult> {
    const url = '/api/tools/bindUserPhone';
    return this.http.post<WxLoginResult>(`${url}`, data, httpOptions)
      .pipe(
        tap((response) => {
          if (response.result.user) {
            this.isLoggedIn = true;
            this.userInfo = response.result.user;
            this.accesstoken = response.result.id;
          }
        }),
      );
  }

  signup(user: SignUpUser): Observable<SignUpResult> {
    // 注册
    const url = '/signUp';
    return this.http.post<SignUpResult>(`${url}`, user, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  /*退出系统*/
  deleteAccessToken(data: {}): Observable<{ msg: any }> {
    const url = 'api/users/deleteAccessToken'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ msg: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => { }),
      );
  }

  // 设置公司隐藏的未使用模块
  setModuleHideListURL(data: {}): Observable<{ result: any }> {
    const url = 'api/tools/setModuleHideList'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => { }),
      );
  }

  // 阻止事件冒泡
  stopPropagation(e) {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    } else {
      e.cancelBubble = true;
    }
  }

  // 设置textarea高度自适应
  setTextAreaHeighAuto(element) {
    setTimeout(() => {
      if ($(element).length <= 0) {
        return;
      }
      const textarea = $(element);
      textarea.height(textarea[0].scrollHeight);
    }, 100);
  }

  // 返回函数
  goBack(): void {
    this.hideSettingTabs = false;
    this.location.back();
  }

  // 获取是否对员工隐藏单价信息
  getPriceShowInfoURL(data: {}): Observable<{ result: any }> {
    const url = 'api/tools/getPriceShowInfo'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 获取是否对员工隐藏单价信息
  getPriceShowInfo() {
    const data = {
      accesstoken: this.accesstoken,
    };
    if (!this.userInfo.orgName) {
      return;
    }
    this.getPriceShowInfoURL(data).subscribe(response => {
      if (response.result) {
        this.hideTaskPrice = response.result.hideTaskPrice;
        if (this.hideTaskPrice && response.result.hideTaskPriceMonth) {
          this.hideTaskPriceStartMonth = response.result.hideTaskPriceMonth;
        } else if (this.hideTaskPrice && !response.result.hideTaskPriceMonth) {
          this.hideTaskPriceStartMonth = '';
        }
        this.hideSalary = response.result.hideSalary;
        if (this.hideSalary && response.result.hideSalaryEndMonth) {
          this.hideSalaryEndMonth = response.result.hideSalaryEndMonth;
        } else if (this.hideSalary && !response.result.hideSalaryEndMonth) {
          this.hideSalaryEndMonth = '';
        }
        this.hideColleague = response.result.hideColleague;
        this.hideTaskList = response.result.hideTaskList;
        this.hideProduction = response.result.hideProduction;
        this.controlScanningOrder = response.result.controlScanningOrder;
        this.fixedSkill = response.result.fixedSkill;
      }
    }, error => {
      this.loadImageShow = true;
      setTimeout(() => {
        this.message.setOptions({
          center: true,
          zIndex: 9999
        });
        this.message['warning']('网络错误，请稍后重试');
        this.loadImageShow = false;
      }, 10000);
      console.log(error);
    });
  }

  getAutoCutoffSalaryMonthDateURL(data: {}): Observable<{ result: any }> {
    const url = 'api/tools/getAutoCutoffSalaryMonthDate'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  getAutoCutoffSalaryMonthDate() {
    const data = {
      accesstoken: this.accesstoken,
    };
    if (!this.userInfo.orgName) {
      return;
    }
    this.getAutoCutoffSalaryMonthDateURL(data).subscribe(response => {
      if (response.result) {
        this.autoCutoffSalaryMonthDate = response.result.date || '1';
      }
    }, error => {
      this.loadImageShow = true;
      setTimeout(() => {
        this.message.setOptions({
          center: true,
          zIndex: 9999
        });
        this.message['warning']('网络错误，请稍后重试');
        this.loadImageShow = false;
      }, 10000);
      console.log(error);
    });
  }

  setAutoCutoffSalaryMonthDate(data: {}): Observable<{ result: any }> {
    const url = 'api/tools/setAutoCutoffSalaryMonthDate'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 对员工隐藏单价信息 -- 设置
  taskPriceShowChange(data: {}): Observable<{ result: any }> {
    const url = 'api/tools/taskPriceShowChange'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 导出 excel 表格函数
  doExcel(tableArr, tabName, colsStyles = null, contentType = null) {
    // tableArr：表格 id
    // tabName 表格名称
    // colsStyles：表格列宽设置；例：colsStyles = [{ wpx: 100 }]，数组的项对应表格的列
    // contentType：表格内容的数据类型设置；例：contentType = [{ name: 'A', value: 's' }]，name 对应表格列表（A，B，C），value 依次对应：b Boolean, e Error, n Number, d Date, s Text, z Stub
    if (!colsStyles) {
      colsStyles = [];
      // 默认设置每列 100 wpx
      for (let i = 0; i < 20; i++) {
        colsStyles.push({
          wpx: 100
        });
      }
    }
    const workbook = XLSX.utils.book_new();
    // 过滤重名的 sheet
    const tabArr = [];
    for (let i = 0; i < tableArr.length; i++) {
      if (tabArr.length === 0) {
        tabArr.push(tableArr[i]);
      } else {
        for (let j = 0; j < tabArr.length; j += 1) {
          if (tableArr[i].sheet === tabArr[j].sheet) {
            tableArr[i].sheet = '';
            tabArr.push(tableArr[i]);
            break;
          } else if (j === tabArr.length - 1 && tableArr[i].sheet !== tabArr[j].sheet) {
            tabArr.push(tableArr[i]);
            break;
          }
        }
      }
    }
    // 过滤特殊字符
    for (let i = 0; i < tabArr.length; i++) {
      let filterChar;
      if (tabArr[i].sheet) {
        filterChar = tabArr[i].sheet;
        const reg = /\\/g; // 匹配 \
        if (reg.test(filterChar)) {
          const str = filterChar.split(reg);
          filterChar = str.join('');
        }
        const str1 = filterChar.split('*');
        filterChar = str1.join('');
        const str2 = filterChar.split('/');
        filterChar = str2.join('');
        const str3 = filterChar.split('[');
        filterChar = str3.join('');
        const str4 = filterChar.split(']');
        filterChar = str4.join('');
        tabArr[i].sheet = filterChar;
      }
      // 暂时所有的数据都以string格式保留，最大程度能让数据保持原样，当时对于数据的求和，需要手动改变一下单元格格式
      const ws = XLSX.utils.table_to_sheet(document.getElementById(tabArr[i].tabId), { raw: true });
      // 定义表格列宽
      if (colsStyles) {
        ws['!cols'] = colsStyles;
        // ws['!cols'] = [{ wpx: 100 }, { wpx: 100 }, { wpx: 100 }, { wpx: 45 }, { wpx: 45 }, { wpx: 45 }, { wpx: 60 }, { wpx: 100 }];
      }
      // 将表格中的数据类型
      if (contentType) {
        for (const key of Object.keys(ws || [])) {
          for (let k = 0; contentType && k < contentType.length; k++) {
            if (contentType[k].name && key.indexOf(contentType[k].name) >= 0) {
              ws[key].t = contentType[k].value;
            }
          }
        }
      }
      XLSX.utils.book_append_sheet(workbook, ws, tabArr[i].sheet);
    }
    XLSX.writeFile(workbook, tabName + '.xlsx');
    // tabArr: 对象数组，格式：tabArr = [{ tabId: 类型为 string, table 的 id, sheet: 下载的excel文件的工作表名称}]
    // tabName: 下载的表格名
  }

  // 获取 cookie
  getCookie(c_name) {
    if (document.cookie && document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + '=');
      if (c_start !== -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(';', c_start);
        if (c_end === -1) {
          c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
  }

  // 删除 cookie
  delCookie(name) {
    const exp: any = new Date();
    exp.setTime(exp.getTime() - 1);
    const cval = this.getCookie(name);
    if (cval != null) {
      document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
    }
  }

  // 对员工隐藏单价信息 -- 设置
  getAllBriefInfo(data: {}): Observable<{ result: any }> {
    const url = 'api/tools/getAllBriefInfo'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 滚动条自动滚动到最底部
  scrollToBottom(element) {
    setTimeout(() => {
      if ($(element).length <= 0) {
        return;
      }
      const scrollHeight = $(element)[0].scrollHeight;
      $(element)[0].scrollTop = scrollHeight;
    }, 100);
  }

  // 随机生成一个字符串，默认生成一个32位字符串
  randomString(len) {
    const length = len || 32;
    const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1*** */
    const maxPos = $chars.length;
    let pwd = '';
    for (let i = 0; i < length; i += 1) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  }

  // 获取IP地址
  getIPInformation(): Observable<{ result: any }> {
    const url = 'api/tools/getIPInformation'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 选择工序
  detailTaskOfSubmitedItems(data: {}): Observable<{ detailItems: any }> {
    const url = 'api/tasks/detailTaskOfSubmitedItems'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ detailItems: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  scrollToTop() {
    $(document).scrollTop(0);
  }

  // 选择工序
  updateCount(data: {}): Observable<{ result: any }> {
    const url = 'api/tasks/updateCount'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 分配工序
  checkAllot(data: {}): Observable<{ result: any }> {
    const url = 'api/tasks/checkAllot'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 添加员工
  confirmAddNewStaffs(data: {}): Observable<{ result: any }> {
    const url = 'api/employees/confirmAddNewStaffs'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 获取公告
  noticeReceive(data: {}): Observable<{ result: any }> {
    const url = 'api/noticeBoards/noticeReceive'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 获取用户头像
  getUserHeadImage(userId) {
    const data = {
      accesstoken: this.accesstoken,
      userId
    };
    this.getUserHeadHttp(data).subscribe(response => {
      if (response.result && response.result.length > 0) {
        this.userInfo.img = {};
        this.userInfo.img.url = 'api/containers/' + this.userInfo.id + '/download/' + response.result[0].filename;
      }
    }, error => {
      this.loadImageShow = true;
      setTimeout(() => {
        this.message.setOptions({
          center: true,
          zIndex: 9999
        });
        this.message['warning']('网络错误，请稍后重试');
        this.loadImageShow = false;
      }, 10000);
    });
  }

  // 获取用户头像请求
  getUserHeadHttp(data: {}): Observable<{ result: any }> {
    const url = 'api/files/getHeadpic'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 单击图片，显示大图
  showBigImageBox(index, images) {
    this.bigImageShow = true;
    this.indexBigImage = index;
    this.bigImageArr = images;
    this.bigPictrue = this.bigImageArr[this.indexBigImage].url;
    const img = new Image();
    img.src = this.bigPictrue;
    const img_w = img.naturalWidth;
    const img_h = img.naturalHeight;
    if (img_w > img_h) {
      $('.showBigPictrueBox img').css({
        'height': 'auto',
        'width': '90%'
      });
    } else {
      $('.showBigPictrueBox img').css({
        'height': '90%',
        'width': 'auto'
      });
    }
    $('.iconList .iconItem').removeClass('iconActive');
    $('.iconList .iconItem').eq(this.indexBigImage).addClass('iconActive');
  }

  // 浏览器刷新，自动登录
  verifyToken(data: {}): Observable<{ result: any }> {
    const url = 'api/employees/verifyToken'.concat('?access_token=').concat(this.accesstoken || sessionStorage.getItem('AccessToken'));
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 各个权限
  tabShow(permission) {
    for (let i = 0; i < permission.length; i++) {
      switch (permission[i]) {
        case 'specimenReading':
          this.adminSpecimenReading = true;
          break;
        case 'specimen':
          this.adminSpecimen = true;
          break;
        case 'specimenAuditing':
          this.adminSpecimenAuditing = true;
          break;
        case 'tradeOrderReading':
          this.adminTradeOrderReading = true;
          break;
        case 'tradeOrder':
          this.adminTradeOrder = true;
          break;
        case 'tradeOrderAuditing':
          this.adminTradeOrderAuditing = true;
          break;
        case 'purchaseOrderReading':
          this.adminPurchaseOrderReading = true;
          break;
        case 'purchaseOrder':
          this.adminPurchaseOrder = true;
          break;
        case 'purchaseOrderAuditing':
          this.adminPurchaseOrderAuditing = true;
          break;
        case 'companyTaskReading':
          this.adminCompanyTaskReading = true;
          break;
        case 'companyTask':
          this.adminCompanyTask = true;
          break;
        case 'companyTaskAuditing':
          this.adminCompanyTaskAuditing = true;
          break;
        case 'workstage':
          this.adminWorkstage = true;
          break;
        case 'bundle':
          this.adminBundle = true;
          break;
        case 'productionData':
          this.adminProductionData = true;
          break;
        case 'schedule':
          this.adminSchedule = true;
          break;
        case 'batchDailyWork':
          this.adminBatchDailyWork = true;
          break;
        case 'staffsReading':
          this.adminStaffsReading = true;
          break;
        case 'staffs':
          this.adminStaffs = true;
          break;
        case 'staffsAuditing':
          this.adminStaffsAuditing = true;
          break;
        case 'companySalaryReading':
          this.adminCompanySalaryReading = true;
          break;
        case 'companySalary':
          this.adminCompanySalary = true;
          break;
        case 'companySalaryAuditing':
          this.adminCompanySalaryAuditing = true;
          break;
        case 'customerBillsReading':
          this.adminCustomerBillsReading = true;
          break;
        case 'customerBills':
          this.adminCustomerBills = true;
          break;
        case 'customerBillsAuditing':
          this.adminCustomerBillsAuditing = true;
          break;
        case 'recordStockReading':
          this.adminRecordStockReading = true;
          break;
        case 'recordStock':
          this.adminRecordStock = true;
          break;
        case 'recordStockAuditing':
          this.adminRecordStockAuditing = true;
          break;
        case 'revenueReading':
          this.adminRevenueReading = true;
          break;
        case 'revenue':
          this.adminRevenue = true;
          break;
        case 'revenueAuditing':
          this.adminRevenueAuditing = true;
          break;
        case 'authority':
          this.adminAuthority = true;
          break;
        case 'auditingReading':
          this.adminAuditingReading = true;
          break;
        case 'auditing':
          this.adminAuditing = true;
          break;
        case 'noticeBoard':
          this.adminNoticeBoard = true;
          break;
      }
    }
  }

  // 删除图片
  removeImgOfTask(data: {}): Observable<{ result: any }> {
    const url = '/api/files/removeImgOfTask'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => { }),
      );
  }

  // 充值支付
  wxPaymentForPC(data: {}): Observable<{ result: any }> {
    const url = 'api/tools/wxPaymentForPC'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 查询用户支付单情况
  findOnePaymentBill(data: {}): Observable<{ result: any }> {
    const url = 'api/paymentBills/findOnePaymentBill'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 实现图片预览
  createImageUrl(event, imageArr) {
    if (!imageArr) {
      imageArr = [];
    }
    const imageFiles = event.target.files;
    for (let i = 0; imageFiles && i < imageFiles.length; i++) {
      if (imageFiles[i]) {
        const obj: any = {};
        obj.fileName = imageFiles[i].name;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          obj.url = e.target.result;
          if (obj && obj.url) {
            obj.index = imageArr.length;
            imageArr.push(obj);
          }
        };
        // the result attribute contains the data as a data:URL representing the file's data as a base64 encoded string
        // 所以可以作为img的预览图片；createObjectURL是另外一种生成base64格式的方式
        reader.readAsDataURL(imageFiles[i]);
      }
    }
  }

  // 为drag&drop实现图片预览
  createImageUrlForDragAndDrop(event, imageArr) {
    if (!imageArr) {
      imageArr = [];
    }
    const imageFiles = event.dataTransfer.files;
    for (let i = 0; imageFiles && i < imageFiles.length; i++) {
      if (imageFiles[i] && (event.dataTransfer.files[i].type === 'image/jpeg'
        || event.dataTransfer.files[i].type === 'image/png'
        || event.dataTransfer.files[i].type === 'image/bmp'
        || event.dataTransfer.files[i].type === 'image/gif'
        || event.dataTransfer.files[i].type === 'image/webp')) {
        const obj: any = {};
        obj.fileName = imageFiles[i].name;
        obj.index = imageArr.length;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          obj.url = e.target.result;
          if (obj && obj.url) {
            imageArr.push(obj);
          }
        };
        // the result attribute contains the data as a data:URL representing the file's data as a base64 encoded string
        // 所以可以作为img的预览图片；createObjectURL是另外一种生成base64格式的方式
        reader.readAsDataURL(imageFiles[i]);
      }
    }
  }

  getFileUrlForDragAndDrop(event, uploadImgArr, urlArr) {
    // this.onFileChange(event.dataTransfer.files);    // notice the "dataTransfer" used instead of "target"
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        if (event.dataTransfer.files[i] && (event.dataTransfer.files[i].type === 'image/jpeg'
          || event.dataTransfer.files[i].type === 'image/png'
          || event.dataTransfer.files[i].type === 'image/bmp'
          || event.dataTransfer.files[i].type === 'image/gif'
          || event.dataTransfer.files[i].type === 'image/webp')) {
          event.dataTransfer.files[i].index = uploadImgArr.length;
          uploadImgArr.push(event.dataTransfer.files[i]);
        }
        // 图片添加完后，进行图片预览
        if (i === event.dataTransfer.files.length - 1) {
          this.createImageUrlForDragAndDrop(event, urlArr);
        }
      }
    }
  }

  // 图片拖拽排序
  sortFileUrlForDragAndDrop(startIndex, endIndex, uploadImgArr = [], urlArr = []) {
    if (uploadImgArr && uploadImgArr.length > 0) {
      [uploadImgArr[startIndex], uploadImgArr[endIndex]] = [uploadImgArr[endIndex], uploadImgArr[startIndex]];
      uploadImgArr.forEach((item, index) => {
        item.index = index;
      });
    }
    // const uploadImgArrItem = uploadImgArr[startIndex];
    // uploadImgArr[startIndex] = uploadImgArr[endIndex];
    // uploadImgArr[endIndex] = uploadImgArrItem;
    // 重新排序赋值index

    if (urlArr && urlArr.length > 0) {
      [urlArr[startIndex], urlArr[endIndex]] = [urlArr[endIndex], urlArr[startIndex]]
      // 重新排序赋值index
      urlArr.forEach((item, index) => {
        item.index = index;
      });
    }
    // const urlArrItem = urlArr[startIndex];
    // urlArr[startIndex] = urlArr[endIndex];
    // urlArr[endIndex] = urlArrItem;
  }

  // 获取生产任务上数列表数据
  getAllStaffsForBatchDailyWork(data: {}): Observable<{ result: any }> {
    const url = 'api/dailyWorks/getAllStaffsForBatchDailyWork'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
        catchError(this.handleError('getAllStaffsForBatchDailyWork', { result: false }))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

  // 路由重定向，是为了刷新当前页面
  // 因为使用 navigate() 时，angular 会检测当前路由是否发生变化，如果没有变化，则不会重新加载当前页面
  redirectTo(uri: string) {
    this.router.navigateByUrl('/DummyComponent', { skipLocationChange: true }).then(() => this.router.navigate([uri]));
  }

  // 给左边 tab 菜单添加激活背景色
  setActiveBgColor(index) {
    this.hideSettingTabs = false;
    clearInterval(this.loopCheckPaymentBill); // 清除计时器
    this.clear = true;
    // 判断积分和会员信息，然后是否需要跳转或者提示
    let module: any;
    if (!this.comIntegral) {
      this.comIntegral = JSON.parse(localStorage.getItem('comIntegral') || '0');
    }
    if (!this.moduleDeadArr) {
      this.moduleDeadArr = JSON.parse(localStorage.getItem('moduleDeadArr') || '[]');
    }
    switch (index) {
      case 'specimen':
        module = this.moduleDeadArr.find(item => {
          return item.name === '样版模块';
        });
        if (this.comIntegral || (module && !module.isOver)) {
          this.addBgColorIndex = index;
          this.router.navigateByUrl('/workspace/company-specimen/home');
        } else {
          this.message.setOptions({ center: true });
          this.message['warning']('【样版模块会员已过期】或【积分不足】，请企业管理员【续费会员】或【充值积分】');
        }
        break;
      case 'tradeOrder':
        module = this.moduleDeadArr.find(item => {
          return item.name === '订单模块';
        });
        if (this.comIntegral || (module && !module.isOver)) {
          this.addBgColorIndex = index;
          this.router.navigateByUrl('/workspace/company-order/home');
        } else {
          this.message.setOptions({ center: true });
          this.message['warning']('【订单模块会员已过期】或【积分不足】，请企业管理员【续费会员】或【充值积分】');
        }
        break;
      case 'purchaseOrder':
        module = this.moduleDeadArr.find(item => {
          return item.name === '采购模块';
        });
        if (this.comIntegral || (module && !module.isOver)) {
          this.addBgColorIndex = index;
          this.router.navigateByUrl('/workspace/company-purchase/home');
        } else {
          this.message.setOptions({ center: true });
          this.message['warning']('【采购模块会员已过期】或【积分不足】，请企业管理员【续费会员】或【充值积分】');
        }
        break;
      case 'task':
        module = this.moduleDeadArr.find(item => {
          return item.name === '生产模块';
        });
        if (this.comIntegral || (module && !module.isOver)) {
          this.addBgColorIndex = index;
          this.router.navigateByUrl('/workspace/company-task/home');
        } else {
          this.message.setOptions({ center: true });
          this.message['warning']('【生产模块会员已过期】或【积分不足】，请企业管理员【续费会员】或【充值积分】');
        }
        break;
      case 'salary':
        module = this.moduleDeadArr.find(item => {
          return item.name === '工资模块';
        });
        if (this.comIntegral || (module && !module.isOver)) {
          this.addBgColorIndex = index;
          this.router.navigateByUrl('/workspace/company-salary/home');
        } else {
          this.message.setOptions({ center: true });
          this.message['warning']('【工资模块会员已过期】或【积分不足】，请企业管理员【续费会员】或【充值积分】');
        }
        break;
      case 'audit':
        module = this.moduleDeadArr.find(item => {
          return item.name === '审核模块';
        });
        this.addBgColorIndex = index;
        this.router.navigateByUrl('/workspace/company-auditing/home');
        // if (this.comIntegral || (module && !module.isOver)) {
        //   this.addBgColorIndex = index;
        //   this.router.navigateByUrl('/workspace/company-auditing/home');
        // } else {
        //   this.message.setOptions({ center: true });
        //   this.message['warning']('【审核模块会员已过期】或【积分不足】，请企业管理员【续费会员】或【充值积分】');
        // }
        break;
      case 'commodity':
        module = this.moduleDeadArr.find(item => {
          return item.name === '仓库模块';
        });
        if (this.comIntegral || (module && !module.isOver)) {
          this.addBgColorIndex = index;
          this.router.navigateByUrl('/workspace/warehouse-management/home');
        } else {
          this.message.setOptions({ center: true });
          this.message['warning']('【仓库模块会员已过期】或【积分不足】，请企业管理员【续费会员】或【充值积分】');
        }
        break;
      case 'customerBills':
        module = this.moduleDeadArr.find(item => {
          return item.name === '账单模块';
        });
        if (this.comIntegral || (module && !module.isOver)) {
          this.addBgColorIndex = index;
          this.router.navigateByUrl('/workspace/customer-bill/home');
        } else {
          this.message.setOptions({ center: true });
          this.message['warning']('【账单模块会员已过期】或【积分不足】，请企业管理员【续费会员】或【充值积分】');
        }
        break;
      case 'revenue':
        module = this.moduleDeadArr.find(item => {
          return item.name === '收支模块';
        });
        if (this.comIntegral || (module && !module.isOver)) {
          this.addBgColorIndex = index;
          this.router.navigateByUrl('/workspace/revenue/home');
        } else {
          this.message.setOptions({ center: true });
          this.message['warning']('【收支模块会员已过期】或【积分不足】，请企业管理员【续费会员】或【充值积分】');
        }
        break;
      case 'employee':
        // 员工上数
        this.router.navigateByUrl('/workspace/daily-work/home/tasks');
        this.addBgColorIndex = index;
        break;
      case 'wage':
        // 员工工资
        this.router.navigateByUrl('/workspace/employee-salary/home');
        this.addBgColorIndex = index;
        break;
      case 'enterprise':
        this.router.navigateByUrl('/workspace/my-boss');
        this.addBgColorIndex = index;
        break;
      default:
        this.addBgColorIndex = index;
        break;
    }
  }

  // 上传文件
  uploadFiles(files, container) {
    return new Promise((resolve) => {
      const form = new FormData(); // FormData 对象
      if (!files || files.length === 0 || files.length > 1) {
        return resolve(false);
      }
      for (let i = 0; i < files.length; i++) {
        // 限制文件小于 4M
        if ((files[i].size / 1024) < (1025 * 4)) {
          form.append('file', files[i], files[i].name);
        }
      }
      const url = '/api/files/uploadFiles'.concat('?access_token=').concat(this.accesstoken); // 接收上传文件的后台地址
      const xhr = new XMLHttpRequest(); // XMLHttpRequest 对象
      xhr.open('post', url, true); // post方式，url为服务器请求地址，true 该参数规定请求是否异步处理。
      xhr.setRequestHeader('container', container);
      xhr.onload = function () {
        // 请求完成
        files = [];
        resolve(true);
      };
      xhr.onerror = function () {
        // 请求失败
        files = [];
        resolve(false);
      };
      xhr.send(form); // 开始上传，发送form数据
    });
  }

  // 获取其他类型相关文件
  getOtherFiles(containerID) {
    const data = {
      accesstoken: this.accesstoken,
      container: `file_${containerID}` // 其他类型文件获取的 container 构成规则，'file_'.concat(id)
    };
    return new Promise((resolve) => {
      this.getOtherFileHttp(data).subscribe(response => {
        if (response.result) {
          resolve(response.result);
        } else {
          resolve([]);
        }
      }, error => {
        setTimeout(() => {
          this.message.setOptions({
            center: true,
            zIndex: 9999
          });
          this.message['warning']('网络错误，请稍后重试');
        }, 10000);
        this.loadImageShow = false;
      });
    });
  }
  // 查询用户支付单情况
  getOtherFileHttp(data: {}): Observable<{ result: any }> {
    const url = 'api/files/getOtherFiles'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 添加新职位
  addNewCharacter(data: {}): Observable<{ result: any }> {
    const url = 'api/employees/addNewCharacter'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 获取企业的职位列表信息及当前用户所扮演的职位
  getCompanyRoleList(data: {}): Observable<{ result: any }> {
    const url = 'api/employees/getCompanyRoleList'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 获取企业的职位列表信息及当前用户所扮演的职位
  saveCharacterPermission(data: {}): Observable<{ result: any }> {
    const url = 'api/employees/saveCharacterPermission'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  // 删除职位
  removeCharacter(data: {}): Observable<{ result: any }> {
    const url = 'api/employees/removeCharacter'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => {
        }),
      );
  }

  getNavigationDriver() {  // 引导流程：在有父子组件的情况下，一定要将driver放到service里面才能更正常地运行
    const driver = new Driver({
      animate: false,
      allowClose: false,
      overlayClickNext: true,    // 对于有跳转的页面比较复杂，暂时这样设置比较适合
      doneBtnText: '我懂了，不再提示', // Text on the final button
      closeBtnText: '下次提示', // Text on the close button for this step
      nextBtnText: '下一步', // Next button text for this step
      prevBtnText: '上一步',
    });
    driver.defineSteps([
      {
        element: '#yangji-notification',
        popover: {
          title: '软件简介：',
          description: `<div style="white-space: pre-wrap;">${this.softwareUpdate}</div>`,
          position: 'mid-center'
        }
      },
      {
        element: '#yangji-learn',
        popover: {
          title: '学习视频',
          description: '第一次使用软件，可以看看我们的软件的介绍视频，也许能够帮到您',
          position: 'bottom'
        }
      },
      {
        element: '#yangji-login',
        popover: {
          title: '登陆和注册区域',
          description: '第一次使用可以在【密码登陆】这里看到【免费注册】，注册之后再【扫码登陆】或者【密码登陆】',
          position: 'left-center'
        }
      },
      {
        element: '#yangji-miniProgram',
        popover: {
          title: '关注小程序',
          description: '这里可以用微信扫一扫使用小程序，小程序和电脑的数据同步',
          position: 'left'
        }
      },
      {
        element: '#yangji-officialAccount', // 在同一个ID块上面做这个操作，需要顺序不要挨着！
        popover: {
          title: '关注公众号',
          description: '这里可以用微信扫一扫关注公众号，关注公众号后方便您与我们联系，里面也可以使用小程序',
          position: 'top'
        },
        onNext: () => {   // 最后一步，这里是完成时候触发的，下次不再提示
          localStorage.setItem('first-yangji', '1');
        },
      }
    ]);
    return driver;
  }

  // 设置图片的大小，为了让图片能够完全显示
  async setImagesSize(images) {
    images = images || [];
    for (let i = 0; images && i < images.length; i++) {
      const image: any = new Image();
      image.src = images[i].url;
      await new Promise((resolve) => {
        image.onload = (res) => {
          const w = image.width;
          const h = image.height;
          if (w > h) {
            images[i].height = 'auto';
            images[i].width = '100%';
          } else {
            images[i].height = '100%';
            images[i].width = 'auto';
          }
          resolve(true);
        };
      });
    }
    return images;
  }

  // 当原生不好写async的时候，用promise包装一层调用，这个是嵌套promise的范例，把promise的resolve放到onload里面去
  async canvasDataURL(path, option) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = path;
      img.onload = function () {   // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/this
        const that: any = this;   // 史上最坑的this指向，因为function 和 arrow函数的不同
        // 默认按比例压缩
        const w: any = (that.width || 1) / option.scale;
        const h: any = (that.height || 1) / option.scale;
        // 生成canvas
        const canvas: any = document.getElementById('compressImageCanvas');
        const ctx: any = canvas.getContext('2d');
        // 创建属性节点
        const anw = document.createAttribute('width');
        anw.nodeValue = w;
        const anh = document.createAttribute('height');
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);
        // 图像质量，quality值越小，所绘制出的图像越模糊
        let quality = 0.7; // 默认图片质量为0.7
        if (option.quality && option.quality <= 1 && option.quality > 0) {
          quality = option.quality;
        }
        const base64 = canvas.toDataURL('image/jpeg', quality);
        // 回调函数返回base64的值
        resolve(base64);
        // callback(base64);
      };
    });
  }

  // 当原生不好写async的时候，用promise包装一层调用，这个是嵌套promise的范例，把promise的resolve放到onload里面去，
  /* 三个参数
  file：一个是文件(类型是图片格式)，
  option：一个是文件压缩的长和宽，quality，数值越小，字节越小
   */
  async photoCompress(file, w) {
    return new Promise((resolve, reject) => {
      const ready = new FileReader();
      /*开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
      ready.readAsDataURL(file);
      const that = this;
      ready.onload = async function () {
        const re = this.result;
        // 为了压缩图片，重新绘制
        await that.canvasDataURL(re, w).then((base64) => {
          // 嵌套的promise
          resolve(base64);
        });
      };
    });
  }

  convertBase64UrlToBlob(urlData) {
    const arr = urlData.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime
    });
  }

  // 上传图片文件方法
  async uploadTaskPhoto(files, container) {
    if (!container) {
      return false;
    }
    // 历史遗留产物，后端需要一个标准位来获取containerID，其实这里的taskId就是一个xyz
    document.cookie = 'taskId=' + container;
    const uploadFiles = files;
    if (!uploadFiles || uploadFiles.length === 0) {
      return;
    }
    if (uploadFiles && uploadFiles.length > 10) {
      this.message.setOptions({
        center: true,
        zIndex: 9999
      });
      this.message['warning']('最多只能上传10张图片');
      return;
    }
    // let compressIndex = 0;
    if (uploadFiles) {
      let xhr;
      // var fileObj = document.getElementById("file").files[0]; // js 获取文件对象
      const url = '/api/files/uploadTaskPhoto'.concat('?access_token=').concat(this.accesstoken); // 接收上传文件的后台地址
      const form = new FormData(); // FormData 对象
      const that = this;
      for (let i = 0; uploadFiles && i < uploadFiles.length; i += 1) {
        uploadFiles[i].index = i;
        let fileObj;
        const resetFileName = new Date().getTime().toString() + that.randomString(5);
        if (uploadFiles[i].part) {
          fileObj = uploadFiles[i].file;
        } else {
          fileObj = uploadFiles[i];
        }
        if (fileObj.size / 1024 > 100) { // 大于100KB，进行压缩上传
          // 计算一下是100KB的多少倍，然后再开方，需要scale缩小多少
          const scale = (Math.sqrt((fileObj.size / 1024) / 100) || 1).toFixed(1);
          await that.photoCompress(fileObj, {
            quality: 0.6,
            scale,
          }).then((base64Codes) => {
            const bl = that.convertBase64UrlToBlob(base64Codes);
            form.append('file', bl, (uploadFiles[i].part ? uploadFiles[i].part + '_' : 'file_') + resetFileName + '_index_' + (uploadFiles[i].index || 0)); // 文件对象
          });
        } else {
          // 小于等于1M 原图上传
          form.append('file', fileObj, (uploadFiles[i].part ? uploadFiles[i].part + '_' : 'file_') + resetFileName + '_index_' + (uploadFiles[i].index || 0)); // 文件对象
        }
      }
      xhr = new XMLHttpRequest(); // XMLHttpRequest 对象
      xhr.open('post', url, true); // post方式，url为服务器请求地址，true 该参数规定请求是否异步处理。
      xhr.onload = function () {
        that.delCookie('taskId');
      }; // 请求完成
      xhr.onerror = function () {
      }; // 请求失败
      xhr.send(form); // 开始上传，发送form数据
    }
  }

  // 从网页的图片或者图片的URL得到base64数据，用于其他用途，比如下载，打印图片等
  getBase64FromHTMLImage(img) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, img.width, img.height);
    return canvas.toDataURL('image/png');
  }

  // 获取合作企业列表
  getAllCustomerHttp(data: {}): Observable<{ result: any }> {
    const url = '/api/customers/getAllCustomer'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => { }),
      );
  }

  // 获取所有合作企业
  getAllCustomer() {
    return new Promise((resole) => {
      const data = {
        accesstoken: this.accesstoken,
      };
      this.getAllCustomerHttp(data).subscribe(response => {
        if (response.result) {
          this.customerList = response.result;
          resole(response.result);
        }
      }, error => {
        setTimeout(() => {
          this.message.setOptions({
            center: true,
            zIndex: 9999
          });
          this.message['warning']('网络错误，请稍后重试');
        }, 10000);
        this.loadImageShow = false;
        console.log('error==' + error);
        resole(false);
      });
    });
  }

  // 限制输入的值为0-3位小数的正数
  testNumber(amount) {
    if (!amount) {
      return;
    } else {
      amount = amount.toString();
    }
    // 验证非负数
    const reg = /^\d+(?=\.{0,1}\d+$|$)/;
    let removeLast = false; // 验证结束后，是否删除最后一位数
    if (amount.substr(amount.length - 1) === '.') {
      // 在输入过程中，最后一位为 '.' 时，补充 '0'来辅助验证
      removeLast = true;
      amount += '0';
    }
    if (!reg.test(amount)) {
      amount = null;
      return null;
    }
    return removeLast ? amount.substr(0, amount.length - 1) : amount;
  }

  // 限制输入的值为0-3位小数的数字，可以是负数
  testAllNumber(amount) {
    if (!amount) {
      return;
    } else {
      amount = amount.toString();
    }
    // 验证
    const reg = /^[-]?\d+(?=\.{0,1}\d+$|$)/;
    let removeLast = false; // 验证结束后，是否删除最后一位数
    if (amount.substr(amount.length - 1) === '.') {
      // 在输入过程中，最后一位为 '.' 时，补充 '0'来辅助验证
      removeLast = true;
      amount += '0';
    }
    if (!reg.test(amount)) {
      amount = null;
      return null;
    }
    return removeLast ? amount.substr(0, amount.length - 1) : amount;
  }

  // 为了HTML中可以调用parseFloat函数
  parseFloat(value) {
    return parseFloat(value) || 0;
  }

  // 获取操作日志列表
  getOperationLog(data: {}): Observable<{ result: any }> {
    const url = '/api/operationLogs/getOperationLog'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => { }),
      );
  }

  getAllLogPublishName(data: {}): Observable<{ result: any }> {
    const url = '/api/operationLogs/getAllLogPublishName'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => { }),
      );
  }

  getEmployeeInformation(data: {}): Observable<{ result: any }> {
    const url = 'api/employees/getEmployeeInformation'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => { }),
      );
  }

  // 添加操作日志
  addOperationLog(data: {}): Observable<{ result: any }> {
    const url = '/api/operationLogs/addOperationLog'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => { }),
      );
  }

  // 验证积分
  checkIntegralApi(data: {}): Observable<{ result: any }> {
    const url = '/api/users/checkIntegral'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => { }),
      );
  }

  // 获取小程序二维码
  getMiniProgramQRcode(data: {}): Observable<{ result: any }> {
    const url = '/api/tools/getMiniProgramQRcode'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => { }),
      );
  }

  // 获取小程序二维码
  getTempletDetailInformation(data: {}): Observable<{ result: any }> {
    const url = '/api/templets/getTempletDetailInformation'.concat('?access_token=').concat(this.accesstoken);
    return this.http.post<{ result: any }>(`${url}`, data, httpOptions)
      .pipe(
        tap((result) => { }),
      );
  }

  checkIntegral(that, moduleName, operateType, hidden = false) {
    return new Promise((resolve, reject) => {
      const data = {
        accesstoken: this.accesstoken,
        moduleName,
        operateType
      };
      this.checkIntegralApi(data).subscribe(response => {
        if (!response.result) {
          that.checkIntegral = false;
          if (!hidden) {
            that.message.setOptions({ center: true, zIndex: 9999 });
            that.message['error']('【会员已过期】或【积分不足】，请企业管理员【续费会员】或【充值积分】');
          }
          resolve(false);
        } else {
          that.checkIntegral = true;
          resolve(true);
        }
      }, error => {
        if (!hidden) {
          that.message.setOptions({ center: true, zIndex: 9999 });
          that.message['error']('操作失败');
        }
        that.checkIntegral = false;
        resolve(false);
      });
    });
  }

  // 发布时，复用生产任务的图片
  AddImageToUploadImgArr(path, option, fileName, uploadImgArr) {
    const img = new Image();
    img.src = path;
    const context = this;
    img.onload = function () {
      const that: any = this;
      // 默认按比例压缩
      const w: any = (that.width || 1) / option.scale;
      const h: any = (that.height || 1) / option.scale;
      // 生成canvas
      const canvas: any = document.getElementById('compressImageCanvas');
      const ctx = canvas.getContext('2d');
      // 创建属性节点
      const anw = document.createAttribute('width');
      anw.nodeValue = w;
      const anh = document.createAttribute('height');
      anh.nodeValue = h;
      canvas.setAttributeNode(anw);
      canvas.setAttributeNode(anh);
      ctx.drawImage(that, 0, 0, w, h);
      // 图像质量，quality值越小，所绘制出的图像越模糊
      let quality = 0.7; // 默认图片质量为0.7
      if (option.quality && option.quality <= 1 && option.quality > 0) {
        quality = option.quality;
      }
      // 返回如"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFC" 的base64 data url格式
      const base64: any = canvas.toDataURL('image/jpeg', quality);
      const file: any = context.convertBase64UrlToBlob(base64);
      file.name = fileName;
      let num = 0;
      for (let i = 0; i < uploadImgArr.length; i++) {
        if (uploadImgArr[i].name === file.name) {
          num++;
          break;
        }
      }
      if (num === 0) {
        uploadImgArr.push(file);
      }
    };
  }

  // 获取该用户本机显示和关闭提示状态
  getAllTipsState() {
    const mid = localStorage.getItem(`showAllTips-${this.userInfo.username}`);
    this.showAllTips = (!mid || mid === '1') ? true : false;
  }

  // 显示所有提示或关闭
  showAllTipsToggle() {
    this.showAllTips = !this.showAllTips;
    localStorage.setItem(`showAllTips-${this.userInfo.username}`, this.showAllTips ? '1' : '0');
  }

  // 这里是标准模板，没有用到，暂时在生产列表有定制化的逻辑
  requestFullScreen(element) {
    // Supports most browsers and their versions.
    const requestMethod = element.requestFullscreen || element.webkitRequestFullScreen || element['mozRequestFullscreen'] || element['msRequestFullscreen'];
    if (requestMethod) { // Native full screen.
      requestMethod.call(element);
    } else { // Older IE.
      this.message.setOptions({ center: true, zIndex: 9999 });
      this.message['warning']('请使用谷歌或者360极速浏览器，或者按F11键');
    }
  }

  // pageScroll 和 PageUp 组合成为了自动缓慢下滑，到底停留一下，然后再滚动到最上面
  pageScroll() {
    window.scrollBy(0, 10); // horizontal and vertical scroll increments
    this.scrollDelay = setTimeout(() => {
      this.pageScroll();
    }, 1000); // scrolls every 1000 milliseconds
    if ((window.innerHeight + window.pageYOffset) >= document.body.scrollHeight) {
      clearTimeout(this.scrollDelay);
      this.scrollDelay = setTimeout(() => {
        this.PageUp();
      }, 2000);
    }
  }
  PageUp() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.pageScroll();
    }, 600);
  }

  // 取消自动滚动播放
  pageScrollCancel() {
    clearTimeout(this.scrollDelay);
  }

  // 检查两个日期时候大于一定的时间间隔
  checkDateRange(date1, date2, range) {
    // calculate the number of days between date1 and date2
    if (!date1 || !date2) {
      return false;
    }
    const daysBetween = (new Date(date2).getTime() - new Date(date1).getTime()) / 86400000;
    if (daysBetween > (range || 367)) {
      return false;
    }
    return true;
  }

  // 自动生成出入货单号，由（年，月，日，时，分）构成
  createShipmentNumber() {
    const y = new Date().getFullYear();
    const m = new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1;
    const d = new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate();
    const h = new Date().getHours() < 10 ? `0${new Date().getHours()}` : new Date().getHours();
    const min = new Date().getMinutes() < 10 ? `0${new Date().getMinutes()}` : new Date().getMinutes();
    const s = new Date().getSeconds() < 10 ? `0${new Date().getSeconds()}` : new Date().getSeconds();
    return `${y}${m}${d}${h}${min}${s}`;
  }

  // 验证0-3位小数点的数字
  checkNumber(event) {
    if (!event) {
      return;
    }
    const reg = /^[0-9]+(.[0-9]{0,3})?$/;
    if (!reg.test(event.target.value)) {
      event.target.value = '';
    }
  }

  // 根据生产任务的department和userid,判断该user是否可见该生产任务，是否需要发送推送信息
  // 部门按照“大管小”的方式，0.老板可见所有生产任务 1.没有设置部门的人员，可见所有；2.没有部门的生产任务，属于所有人
  // 3.如果人员、生产任务都有部门，那么就是大管小，indexof。你所在的部门如果级别比较高，“省办公厅可以看市县文件，反之不行，跨省不行”
  filterAllRelatedUserByDepartment(currentTask, userInfoArray) {
    // 如果该生产任务没有分配部门，则直接返回,所有人可见
    // if (!currentTask.filterDepartmentChar && (!currentTask.departmentArr || currentTask.departmentArr.length === 0)) {
    //   return userInfoArray;
    // }
    // let visibleUserInfoArray = [];
    // if (userInfoArray && userInfoArray.length > 0) {
    //   visibleUserInfoArray = userInfoArray.filter((currentUser) => {
    //     if (!currentUser) {
    //       return false;
    //     }
    //     if (currentUser.identity === 'company') {
    //       // 老板可见
    //       return true;
    //     }
    //     if (!currentUser.department || currentUser.department.trim() == '') {
    //       // 如果该管理员、员工不属于任何部门，那么他就可以看到该生产任务
    //       return true;
    //     }
    //     for (let k = 0; currentTask.departmentArr && k < currentTask.departmentArr.length; k += 1) {
    //       const departmentArray=currentUser.department;
    //       for (let j = 0;j<departmentArray.length; j++) {
    //         if (currentTask.departmentArr[k]==departmentArray[j]|| currentTask.departmentArr[k].startsWith(departmentArray[j]) ) {
    //           return true;
    //         }
    //       }
    //       // if (currentTask.departmentArr[k].indexOf(currentUser.department) >= 0) {
    //       //   return true;
    //       // }

    //     }
    //     return false;
    //   });
    // }
    // return visibleUserInfoArray;
    if (!currentTask) {
      return [];
    }
    if (!currentTask.departmentArr || currentTask.departmentArr.length == 0) {
      return userInfoArray;
    }
    let visibleUserInfoArray = [];
    for (let i = 0; i< userInfoArray.length; i++ ) {
      if ( !userInfoArray[i].department || userInfoArray[i].department.trim() === '') {
        visibleUserInfoArray.push( userInfoArray[i] );
      } else {
        let taskDepartmentStr = currentTask.departmentArr.join(',');
        if (this.isUserDepartmentRelated(taskDepartmentStr, userInfoArray[i].department) ) {
          visibleUserInfoArray.push(userInfoArray[i]);
        }
      }
    }
    return visibleUserInfoArray;
  }

  // 根据登录人员能看到的部门，过滤人员数组
  filterAllRelatedUserByLoginUserDepartment(currentUserInfo, userInfoArray) {
    if (!currentUserInfo) {
      return [];
    }
    let department ='';
    if (currentUserInfo) {
      if (currentUserInfo.identity !='company' && currentUserInfo.state && currentUserInfo.state ==2 && currentUserInfo.department && currentUserInfo.department.trim() !='') {
        department = currentUserInfo.department.trim();
      }
    }
    if (!department || department.trim() === '') {
      return userInfoArray;
    } else {
      let tempStaffs = [];
      for (let i = 0; i < userInfoArray.length; i += 1) {
        if (!userInfoArray[i].department || userInfoArray[i].department.trim() === '') {
          tempStaffs.push(userInfoArray[i]);
        } else if (this.isUserDepartmentRelated(department, userInfoArray[i].department)) {
          tempStaffs.push(userInfoArray[i]);
        }
      }
      return tempStaffs; 
    }
  }

  // 合计各规格颜色的总数量
  calculateTotalAmount(data) {
    if (!data || data.length === 0) {
      return {
        allSizeTotal: 0,
        totalAmountArr: []
      };
    }
    this.allSizeTotal = 0;
    this.totalAmountArr = JSON.parse(JSON.stringify(data[0].sizeArr || []));
    // 初始化 total
    for (let i = 0; this.totalAmountArr && i < this.totalAmountArr.length; i++) {
      this.totalAmountArr[i].total = 0;
    }
    // 计算各个尺码的数量总和
    for (let i = 0; data && i < data.length; i++) {
      data[i].colorTotalAmount = 0;
      for (let j = 0; data[i].sizeArr && j < data[i].sizeArr.length; j++) {
        if (data[i].sizeArr[j].amount) {
          this.allSizeTotal += parseFloat(data[i].sizeArr[j].amount || 0);
          this.totalAmountArr[j].total += parseFloat(data[i].sizeArr[j].amount || 0);
          data[i].colorTotalAmount += parseFloat(data[i].sizeArr[j].amount || 0);
        }
      }
    }
    return {
      allSizeTotal: this.allSizeTotal,
      totalAmountArr: this.totalAmountArr
    };
  }

  shortcutKeyUpgrade(e, index) {
    const $target = $(e.target);
    const $currentCell = $target.closest('td');

    // 动态获取当前列索引（从1开始，匹配 nth-child）
    const currentColumnIndex = $currentCell.index() + 1;

    if (e.keyCode === 37) {
      // 左←个input
      const prevInput = $target.closest('.arrowMove').prev().find('input');
      if (prevInput && prevInput.length > 0) {
        $('.codeListWrap').hide();
        prevInput.select();
      }
    } else if (e.keyCode === 38) {
      // 上↑个input - 使用当前列索引
      const prevInput = $target.closest('.arrowMove').closest('tr').prev().find(`td:nth-child(${currentColumnIndex})`).find('input');
      if (prevInput && prevInput.length > 0) {
        $('.codeListWrap').hide();
        prevInput.select();
      }
    } else if (e.keyCode === 39) {
      // 右→个input
      const prevInput = $target.closest('.arrowMove').next().find('input');
      if (prevInput && prevInput.length > 0) {
        $('.codeListWrap').hide();
        prevInput.select();
      }
    } else if (e.keyCode === 40 || e.keyCode === 13) {
      // 下↓个input、enter - 使用当前列索引
      const nextInput = $target.closest('.arrowMove').closest('tr').next().find(`td:nth-child(${currentColumnIndex})`).find('input');
      if (nextInput && nextInput.length > 0) {
        $('.codeListWrap').hide();
        nextInput.select();
      }
    }
  }

  addExtraDepartment(departmentArr, allDepartmentArr) {
    // allDepartmentArr 可能是对象数组，也可能是字符串数组
    const tempDepartment = [];
    if (allDepartmentArr && allDepartmentArr.length > 0) {
      const firstItem = allDepartmentArr[0];
      // 检查是否是字符串数组
      if (typeof firstItem === 'string') {
        // 将字符串数组添加到临时数组
        (allDepartmentArr || []).forEach(element => {
          if (!tempDepartment.includes((element))) {
            tempDepartment.push((element));
          }
        });
      } else {
        // 将对象数组转换为字符串数组
        (allDepartmentArr || []).forEach(element => {
          if (!tempDepartment.includes((element && element.label))) {
            tempDepartment.push((element && element.label));
          }
        });
      }
    }
    // 把当前的部门也加入，避免有孤魂野鬼，可以复位清理掉
    for (let i = 0; departmentArr && i < departmentArr.length; i += 1) {
      if (departmentArr[i] && !tempDepartment.includes(departmentArr[i])) {
        allDepartmentArr.push({ label: departmentArr[i], value: departmentArr[i] });
      }
    }
  }

  // 限查前两年及下一个月以后
  disabledMonth(time) {
    const inputDate = new Date(time).getTime();
    const twoYearAgo = new Date().setFullYear(new Date().getFullYear() - 2);
    const hour = ((twoYearAgo - inputDate) / 1000) / 3600;
    // 大于0小于1是传相近时间，还有种默认到月一号，要解决两种识别
    if (hour > 1 && new Date(time).getDate() == 1 && hour < new Date().getDate() * 24) {
      return false;
    } else {
      return hour > 1 || time > new Date().getTime();
    }
  }

  // 只限前两年
  disabledMonthStart(time) {
    const inputDate = new Date(time).getTime();
    const twoYearAgo = new Date().setFullYear(new Date().getFullYear() - 2);
    const hour = ((twoYearAgo - inputDate) / 1000) / 3600;
    // 大于0小于1是传相近时间，还有种默认到月一号，要解决两种识别
    if (hour > 1 && new Date(time).getDate() == 1 && hour < new Date().getDate() * 24) {
      return false;
    } else {
      return hour > 1;
    }
  }

  // 只限前3年
  disabledMonthStartForCustomerBill(time) {
    const inputDate = new Date(time).getTime();
    const YearAgo = new Date().setFullYear(new Date().getFullYear() - 3);
    const hour = ((YearAgo - inputDate) / 1000) / 3600;
    // 大于0小于1是传相近时间，还有种默认到月一号，要解决两种识别
    if (hour > 1 && new Date(time).getDate() == 1 && hour < new Date().getDate() * 24) {
      return false;
    } else {
      return hour > 1;
    }
  }

  // 限查前两年及下一个月以后
  disabledDay(time) {
    const inputDate = new Date(time).getTime();
    const twoYearAgo = new Date().setFullYear(new Date().getFullYear() - 2);
    const hour = ((twoYearAgo - inputDate) / 1000) / 3600; // 差多少小时？不超一天24小时允许查
    return hour >= 24 || time > new Date().getTime();
  }

  // 默认限前两年
  disabledDayStart(time) {
    const inputDate = new Date(time).getTime();
    const twoYearAgo = new Date().setFullYear(new Date().getFullYear() - 2);
    const hour = ((twoYearAgo - inputDate) / 1000) / 3600; // 差多少小时？不超一天24小时允许查
    return hour >= 24;
  }

  // 默认限前3年
  disabledDayStartFor3Years(time) {
    const inputDate = new Date(time).getTime();
    const twoYearAgo = new Date().setFullYear(new Date().getFullYear() - 3);
    const hour = ((twoYearAgo - inputDate) / 1000) / 3600; // 差多少小时？不超一天24小时允许查
    return hour >= 24;
  }

  // 获取默认模板 参数：模板状态 返回值模板数据
  getDefaultTemplate(state) {
    const template: Record<string, any> = {
      state,
      id: 'default',
      default: true,
      templetName: '默认模板',
    };
    switch (state) {
      // 工序
      case 0:
        template.templetList = [
          { name: '裁床', price: '0.11', remark: '' },
          { name: '落弯贴袋', price: '0.14', remark: '' },
          { name: '落袋布', price: '0.14', remark: '' },
          { name: '锁链车袋衬', price: '0.16', remark: '' },
          { name: '车前袋', price: '0.5', remark: '' },
          { name: '定洗水唛装胶带', price: '0.15', remark: '' },
          { name: '车尺码唛', price: '0.1', remark: '' },
          { name: '后袋口', price: '0.11', remark: '' },
          { name: '双针装表袋', price: '0.31', remark: '' },
          { name: '双针运纽牌', price: '0.21', remark: '' },
          { name: '单针车袋衬装饰线', price: '0.12', remark: '' },
          { name: '打后袋暗折', price: '0.18', remark: '' },
          { name: '落拉链剪线头', price: '0.23', remark: '' },
          { name: '落双牌', price: '0.21', remark: '' },
          { name: '拉纽牌线', price: '0.05', remark: '' },
          { name: '机头后浪埋夹', price: '0.24', remark: '' },
          { name: '打后幅明折', price: '0.24', remark: '' },
          { name: '压后幅', price: '0.28', remark: '' },
          { name: '平车接后袋', price: '0.24', remark: '' },
          { name: '装后袋有骨位剪线头', price: '0.69', remark: '' },
          { name: '单针压底浪', price: '0.18', remark: '' },
          { name: '平车排比', price: '0.26', remark: '' },
          { name: '单针压鼻骨', price: '0.17', remark: '' },
          { name: '容裤身一周', price: '0.15', remark: '' },
          { name: '三线弯袋贴', price: '0.12', remark: '' },
          { name: '大烫', price: '0.5', remark: '' },
          { name: '打包装', price: '0.2', remark: '' },
        ];
        break;
      // 进度
      case 1:
        template.templetList = [
          { location: '', manager: '', name: '裁剪', price: 0 },
          { location: '', manager: '', name: '印绣花', price: 0 },
          { location: '', manager: '', name: '车缝', price: 0 },
          { location: '', manager: '', name: '洗水', price: 0 },
          { location: '', manager: '', name: '后整', price: 0 },
          { location: '', manager: '', name: '出货', price: 0 },
        ];
        break;
      // 物料详情
      case 2:
        template.templetList = [
          ['物料名称', '物料编号', '颜色', '色号', '规格', '单位', '部位', '单件用量', '单件损耗', '数量', '总用量', '单价', '来源/供应商'],
          ['拉链', 'L-101', '黑色', '#000', '10mm*10mm', '个', '身前', '1', '2%', '100', '102', '0.1', '本厂']
        ];
        break;
      // 成本
      case 3:
        template.templetList = [
          { name: '印花', price: 0.5 },
          { name: '绣花', price: 0.5 },
          { name: '洗水', price: 0.5 },
          { name: '房租', price: 0.5 },
          { name: '水电费', price: 0.5 },
          { name: '损耗', price: 0.5 },
          { name: '管理费', price: 0.5 },
          { name: '运费', price: 0.5 },
          { name: '其他', price: 0.5 },
        ];
        break;
      // 成品尺寸
      case 4:
        template.templetList = [
          ['尺码', 'S', 'M', 'L', 'XL'],
          ['胸围', '82', '86', '90', '96'],
          ['衣长', '65', '68', '70', '73'],
          ['肩宽', '35', '36', '37', '38'],
          ['腰围', '70', '74', '76', '80'],
        ];
        break;
      // 工艺要求
      case 5:
        template.remarks = `1、缝线：
      缝线均匀，无跳线、断线或线头。
      线迹密度符合标准（通常 3-4 针/厘米）。
2、接缝：
      接缝牢固，无脱线或开裂。
      特殊部位（如肩线、袖窿）需加固。
3、对位：
      图案、条纹或格子需对位准确。
      对称部位（如袖口、口袋）需一致。
4、熨烫：
      缝制过程中需及时熨烫，确保平整。
      避免烫焦或烫黄面料。
          `;
        break;
      // 采购详情
      case 6:
        template.templetList = [
          ['物料名称', '物料编号', '颜色', '色号', '规格', '单位', '数量', '单价', '金额', '来源/供应商'],
          ['缝纫线', 'F101', '黑色', '#000', '50mm*60mm', '个', '1000', '5', '5000', '本厂'],
          ['拉链', 'L101', '棕色', '#053107', '3mm*3mm', '个', '1000', '0.4', '400', '本厂'],
          ['纽扣', 'N101', '红色', '#255478', '6mm*6mm', '个', '1000', '0.8', '800', '本厂'],
          ['松紧带', 'S101', '蓝色', '#00f', '20mm*90mm', '个', '1000', '1', '1000', '本厂'],
        ];
        break;
      // 备注信息
      case 7:
        template.remarks = `1、成品尺寸需符合设计图纸要求，误差在允许范围内。
2、无污渍、破损、色差等问题。缝线整齐，无跳线或线头。
3、拉链、纽扣等功能部件需正常使用。
4、弹性面料需测试弹性恢复性能。`;
        break;
      // 质量要求
      case 8:
        template.remarks = `1、婴幼儿服装(3岁以下)强制符合GB31701-2015 A类标准。
2、儿童服装(3-14岁)可选GB31701-2015或GB18401-2010(A/B/C)类。
3、成人服装(14岁以上)执行GB18401-2010标准按直接接触皮肤、非直接接触皮肤分类`;
        break;
      // 违约责任
      case 9:
        template.remarks = `1、质量缺陷‌:
  承揽人交付的服装存在色牢度不足、尺寸偏差等质量问题，定作人可拒收并要求重作或赔偿‌。
2、逾期交货‌:
  因逾期导致服装过季，违约方需赔偿包括预期利润在内的全部损失（如案例中逾期交货的连衣裙订单）。
3、消费者权益保护‌:
  根据《消费者权益保护法》，消费者可要求退货、更换或修理存在质量问题的服装，费用由经营者承担‌。`;
        break;
      // 规格详情
      case 10:
        template.templetList = [
          {
            color: '白色',
            colorTotalAmount: 0,
            sizeArr: [
              { size: 'XXS', amount: null },
              { size: 'XS', amount: null },
              { size: 'S', amount: null },
              { size: 'M', amount: null },
              { size: 'L', amount: null },
            ]
          },
          {
            color: '灰色',
            colorTotalAmount: 0,
            sizeArr: [
              { size: 'XXS', amount: null },
              { size: 'XS', amount: null },
              { size: 'S', amount: null },
              { size: 'M', amount: null },
              { size: 'L', amount: null },
            ]
          },
          {
            color: '绿色',
            colorTotalAmount: 0,
            sizeArr: [
              { size: 'XXS', amount: null },
              { size: 'XS', amount: null },
              { size: 'S', amount: null },
              { size: 'M', amount: null },
              { size: 'L', amount: null },
            ]
          },
          {
            color: '棕色',
            colorTotalAmount: 0,
            sizeArr: [
              { size: 'XXS', amount: null },
              { size: 'XS', amount: null },
              { size: 'S', amount: null },
              { size: 'M', amount: null },
              { size: 'L', amount: null },
            ]
          }
        ];
        break;
      // 其他工资
      case 12:
        template.templetList = [
          { baseSalary: '5000' },
          { workPrice: '' },
          { percentagePrice: '' },
          { name: '全勤奖', money: '100' },
          { name: '生活补贴', money: '100' },
          { name: '应扣伙食费', money: '-100' },
          { name: '应扣水电费', money: '-100' },
        ];
        break;
      // 打非部位
      case 15:
        template.templetList = ['主身', '前幅', '帽子', '后幅', '左袖', '右袖', '裤前腿', '裤后腿'];
        break;
      default:
        return template.templetList = [];
    }
    return [template];
  }

  //深度拷贝，对象数组直接赋值，可能形成相同引用，需要深度拷贝，先手写实现，后续如果需要引入loadsh更好
  deepClone<T>(obj: T): T {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
    if (obj instanceof Date) {
      return new Date(obj.getTime()) as any;
    }
    if (obj instanceof Array) {
      return obj.map(item => this.deepClone(item)) as any;
    }
    const cloned = {} as T;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        cloned[key] = this.deepClone(obj[key]);
      }
    }
    return cloned;
  }

   /**
   * 判断员工部门与任务部门是否有关系
   * @param {any} currentUserDepartmentStr - 当前员工部门
   * @param {any} needSelectDepartmentStr - 需要选择的部门  多部门情况下，必须是某部门跟当前员工相同，或者 是当前员工部门的下级
   * @returns {boolean} 多部门情况下，必须是某部门跟当前员工相同，或者 是当前员工部门的下级
   */
  isUserDepartmentRelated(currentUserDepartmentStr:any, needSelectDepartmentStr:any): boolean {
    let bRelated = false;
    if (!currentUserDepartmentStr || !needSelectDepartmentStr) return bRelated;
    // 1. 完全相等
    if (currentUserDepartmentStr === needSelectDepartmentStr) return true;
    //多部门相等或者查找下级
    let cuDepartmentStr: string = '' + currentUserDepartmentStr;
    let nsDepartmentStr: string = '' + needSelectDepartmentStr;
    const userDepartments = cuDepartmentStr.split(',');
    const selectDepartments = nsDepartmentStr.split(',');
    for (let i = 0; i<userDepartments.length; i += 1) {
      for (let j = 0; j<selectDepartments.length; j += 1) {
        //多部门拆分后，相等或者选择的部门是当前部门的下级 去掉空白项
        if (userDepartments[i].trim() !== ''&& selectDepartments[j].trim() !== '') {
          if ( userDepartments[i].trim() === selectDepartments[j].trim() || (selectDepartments[j].trim()).startsWith(`${userDepartments[i].trim()}>`)) {
            bRelated = true;
            break;
          }
        }
      }
    }
    return bRelated;
  }

  /**
   * 判断选择的部门是否有父子关系，判断选择的部门是否大于3个
   * @param {Array<any>} departmentArr - 当前员工部门
   * @param {number} count - 当前员工部门
   * @returns {any}  返回的是结构体
   */
  checkDepartmentRelatedAndCount(departmentArr, count:number = 9999): any {
    const returnObj = {
      checkOk: true,
      msg: ''
    }
    // if (!departmentArr ||departmentArr.length == 0) {
    //     return returnObj;
    // }
    
    // if (departmentArr.length > count) {
    //   returnObj.msg  = "选择的部门大于" + count + "个";
    //   returnObj.checkOk = false;
    //   return returnObj;
    // }
    // for (let i = 0; i < departmentArr.length; i += 1) {
    //   for (let j = i + 1; j < departmentArr.length; j += 1) {
    //     // 检查 arr[i] 是否包含 arr[j] 或 arr[j] 是否包含 arr[i]
    //     if (departmentArr[i].startsWith(departmentArr[j] + '>') || departmentArr[j].startsWith(`${departmentArr[i]}>`) ) {
    //       returnObj.msg = '存在父部门包含子部门，请检查【' + departmentArr[i] + '】，【' + departmentArr[j] + '】';
    //       returnObj.checkOk = false;
    //       break;
    //     }
    //   }
    // }
    return returnObj;
  }

  /**
   * 通用对象数组排序函数
   * 根据指定属性、优先值和字符串长度进行排序 需要排序的字段 priorityValue 跟它相同的排在最前面
   */
  // 通用排序函数
  sortObjectsByProperty(arr:Array<any>, propertyName:string, priorityValue:string = null) {
    // 复制数组避免修改原数组
    const sortedArr = [...arr];
    // 自定义排序函数
    sortedArr.sort((a, b) => {
        const valueA = a[propertyName] || '';
        const valueB = b[propertyName] || '';
        // 如果指定了优先值，该值排在最前面
        if (priorityValue !== null) {
            if (valueA === priorityValue && valueB !== priorityValue) {
                return -1;
            }
            if (valueA !== priorityValue && valueB === priorityValue) {
                return 1;
            }
            // 两个都是优先值，保持相对顺序
            if (valueA === priorityValue && valueB === priorityValue) {
                return 0;
            }
        }
        // 处理空字符串的情况
        if (valueA === '' && valueB !== '') {
            return 1;
        }
        if (valueA !== '' && valueB === '') {
            return -1;
        }
        if (valueA === '' && valueB === '') {
            return 0;
        }
        // 按照字符串长度降序排序
        const lengthDiff = valueB.length - valueA.length;
        if (lengthDiff !== 0) {
            return lengthDiff;
        }
        // 长度相同则按字母顺序排序
        return valueA.localeCompare(valueB);
    });
    return sortedArr;
  }

  // 去除小数点后面最后的0
  removeDecimalZeros(numTotal: any): number {
    const num = parseFloat(numTotal);
    return isNaN(num) || !isFinite(num) ? 0 : parseFloat(num.toString());
  }

  // 计算行合计
  genRowTotal(item) {
    let total = 0;
    if (!item || !item.sizeArr || item.sizeArr.length == 0) {
      return total;
    }
    item.sizeArr.map(size => {  
      total += this.removeDecimalZeros(size.amount || 0);
    });
    return total;
  }

  // 计算列合计
  genColumnTotal(dataArray, genAllTotal = true) {
    let  totalAmountArr = [];
    if (!dataArray || dataArray.length==0 || !dataArray[0].sizeArr || dataArray[0].sizeArr.length == 0 ) {
      return totalAmountArr;
    }
    let allSizeTotal = 0;
    totalAmountArr = Array.from({ length: dataArray[0].sizeArr.length + 1 }, () => ({ total: 0 }));
    if (!genAllTotal) {
      totalAmountArr = Array.from({ length: dataArray[0].sizeArr.length }, () => ({ total: 0 }));
    }
    // 初始化 total
    for (let i = 0; totalAmountArr && i < totalAmountArr.length; i += 1) {
      totalAmountArr[i].total = 0;
    }
    // // 计算各个规格的数量总和
    for (let i = 0; i < dataArray.length; i += 1) {
      for (let j = 0; j < dataArray[i].sizeArr.length; j += 1) {
        const sizeItem = dataArray[i].sizeArr[j];
        if (sizeItem.amount) {
          allSizeTotal = Math.round((allSizeTotal + parseFloat(sizeItem.amount || 0)) * 1e12) / 1e12;
          totalAmountArr[j].total = Math.round((totalAmountArr[j].total + parseFloat(sizeItem.amount)) * 1e12) / 1e12;
        }
      }
    }
    if (genAllTotal) {
      totalAmountArr[totalAmountArr.length-1].total = allSizeTotal;
    }
    return totalAmountArr;
  }

  // 简化版本 - 只删除空行，不添加新行
  cleanEmptyRowsOnly(table: any): void {
    if (!table) return;
    const currentData = table.getData();
    if (!currentData || currentData.length <= 1) return;
    // 收集要删除的行索引（从第二行开始）
    const rowsToDelete: number[] = [];
    for (let i = 1; i < currentData.length; i++) {
      if (!this.isValidRow(currentData[i])) {
        rowsToDelete.push(i);
      }
    }
    // 从后向前删除，避免索引变化
    for (let i = rowsToDelete.length - 1; i >= 0; i--) {
      table.deleteRow(rowsToDelete[i], 1);
    }
    //const finalData = table.getData();
    // 可选：刷新表格
    if (typeof table.refresh === 'function') {
      table.refresh();
    }
  }

  // 检查行是否为有效数据行
  isValidRow(row: any[]): boolean {
    if (!Array.isArray(row) || row.length === 0) {
      return false;
    }
    // 检查行中是否有非空值
    for (let cell of row) {
      if (this.isValidCell(cell)) {
        return true;
      }
    }
    return false;
  }
  
  // 检查单元格是否为有效数据
  isValidCell(cell: any): boolean {
    // 检查null、undefined
    if (cell === null || cell === undefined) {
      return false;
    }
    // 检查字符串（去空格后是否为空）
    if (typeof cell === 'string') {
      return (cell.trim() != '' && !cell.trim().startsWith('=') && this.removeDecimalZeros(cell) != 0);
    }
    // 数字0是有效值
    if (typeof cell === 'number') {
      return true;
    }
    // 布尔值是有效值
    if (typeof cell === 'boolean') {
      return true;
    }
    // 其他类型（如对象、数组），只要不是空字符串就是有效
    return cell !== '';
  }

  // 获取不重复时间戳
  getUniqueStr(): string {
    return Date.now().toString() + Math.random().toString().substr(2, 6);
  }

  // 判断是否有特殊字符和空格
  hasSpecialCharacters(str) {
    // 匹配：空格、英文标点、中文标点
    const specialChars = /[\s~`!@#$%^&*()\-_+=\[\]{}|\\:;"'<,>.?/\u3000-\u303F\uff00-\uffef]/;
    return specialChars.test(str);
  }

  // 格式化百分比，保留1位小数
  formatNumberFixedToDecimal(value: any, fixedCount: number = 1): number {
    if (value == null) return 0;
    const num = Number(value);
    if (isNaN(num)) return 0;
    if (fixedCount <= 0) {
      return Math.floor(num);
    }
    // 先将数字转换为固定精度的字符串，再解析为整数
    const preciseStr = num.toFixed(12); // 使用足够的精度
    const [integerPart, decimalPart = ''] = preciseStr.split('.');
    // 处理小数部分
    let decimalStr = (decimalPart || '').padEnd(fixedCount, '0');
    decimalStr = decimalStr.substring(0, fixedCount);
    // 构建结果字符串
    const resultStr = `${integerPart}.${decimalStr}`;
    const resultFloat = parseFloat(resultStr);
    // 转换为数字
    return resultFloat;
  }

  // 加法
  add(...numbers): Decimal {
    let processedNumbers = numbers;
    if (numbers.length === 1 && Array.isArray(numbers[0])) {
      processedNumbers = numbers[0];
    }
    if (processedNumbers.length === 0) {
      return new Decimal(0);
    }
    return processedNumbers.reduce((total, num) =>
      total.plus(new Decimal(num || 0))
    , new Decimal(0));
  }
  
  // 减法 - 使用简写形式
  subtract(...numbers): Decimal {
    let processedNumbers = numbers;
    if (numbers.length === 1 && Array.isArray(numbers[0])) {
      processedNumbers = numbers[0];
    }
    if (processedNumbers.length === 0) {
      return new Decimal(0);
    }
    if (processedNumbers.length === 1) {
      return new Decimal(processedNumbers[0] || 0);
    }
    const first = new Decimal(processedNumbers[0] || 0);
    return processedNumbers.slice(1).reduce((total, num) =>
      total.minus(new Decimal(num || 0))
    , first);
  }
  
  // 乘法 - 使用简写形式
  multiply(...numbers): Decimal {
    let processedNumbers = numbers;
    if (numbers.length === 1 && Array.isArray(numbers[0])) {
      processedNumbers = numbers[0];
    }
    if (processedNumbers.length === 0) {
      return new Decimal(0);
    }
    if (processedNumbers.length === 1) {
      return new Decimal(processedNumbers[0] || 0);
    }
    return processedNumbers.reduce((total, num) =>
      total.times(new Decimal(num || 0))
    , new Decimal(1));
  }

  toNumber(value, decimals = null, mode = Decimal.ROUND_HALF_UP) {
    // 模式说明
      //   const roundingModes = {
      //     'ROUND_UP': Decimal.ROUND_UP,           // 远离零的方向（向上取整的绝对值）
      //     'ROUND_DOWN': Decimal.ROUND_DOWN,       // 向零的方向（截断）进度条的时候99.9999% 需要保留成99.9%s时会用到
      //     'ROUND_CEIL': Decimal.ROUND_CEIL,       // 向正无穷大
      //     'ROUND_FLOOR': Decimal.ROUND_FLOOR,     // 向负无穷大
      //     'ROUND_HALF_UP': Decimal.ROUND_HALF_UP, // 四舍五入 一般计算结果保留3位或者4位小数时用到
      //     'ROUND_HALF_DOWN': Decimal.ROUND_HALF_DOWN, // 五舍六入
      //     'ROUND_HALF_EVEN': Decimal.ROUND_HALF_EVEN, // 银行家舍入法
      //     'ROUND_HALF_CEIL': Decimal.ROUND_HALF_CEIL, // 向正无穷大半数舍入
      //     'ROUND_HALF_FLOOR': Decimal.ROUND_HALF_FLOOR, // 向负无穷大半数舍入
      // };
      const deciamlValue = this.toDecimal(value);
      if (decimals != null) {
        // 需要保留小数位
        return Number(deciamlValue.toDecimalPlaces(decimals, mode).toString());
      }
      return Number(deciamlValue.valueOf());
  }

  toDecimal(value) {
    Decimal.set({ precision: 50 });
    if (value) {
      if (value instanceof Decimal) {
        return value;
      }
      return new Decimal(value);
    }
    return new Decimal(0);
  }
}
